/* eslint-disable */
import { createContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  isPositiveInteger,
  onlyLettersAndSpaces,
  isValidEmail,
  calculateDifferenceYears,
} from "../utils/utils";
import { isValid, isBefore, format, parse } from "date-fns";
import { isEmptyObject, roundNumber } from "../utils/utils";
const GestionAtencionContext = createContext();
//
// ################################################################################
// GA
//
const initialGaAction = {
  cu: "new",
  idGestionAtencion: "",
  idGestionAtencionEstado: "",
};
//
// ################################################################################
// CLIENTE
//
const initialCliente = {
  id: "",
  tipoDocumento: "",
  numeroDocumento: "",
  numeroCuitCuil: "",
  nombre: "",
  apellido: "",
  genero: "",
  fechaNacimiento: null,
  edadActual: 0,
  eMail: "",
  telefonoMovil: "",
  telefonoFijo: "",
  domicilio: "",
  localidad: "",
  departamento: "",
  provincia: "",
  pais: "",
  codigoPostal: "",
  actividad: [],
  otraActividad: "",
  ocupacion: [],
  otraOcupacion: "",
};
//
// ################################################################################
// RECETA
//
const initialRecetaLejos = {
  lejosCheck: false,
  lejosOdEsfera: 0,
  lejosOdCilindro: 0,
  lejosOdEje: 0,
  lejosOdPrisma: 0,
  lejosOdPrismaSelect: "",
  lejosOdEjePrisma: 0,
  lejosOiEsfera: 0,
  lejosOiCilindro: 0,
  lejosOiEje: 0,
  lejosOiPrisma: 0,
  lejosOiPrismaSelect: "",
  lejosOiEjePrisma: 0,
};

const initialRecetaCerca = {
  cercaCheck: false,
  cercaOdEsfera: 0,
  cercaOdCilindro: 0,
  cercaOdEje: 0,
  cercaOdPrisma: 0,
  cercaOdPrismaSelect: "",
  cercaOdEjePrisma: 0,
  cercaOiEsfera: 0,
  cercaOiCilindro: 0,
  cercaOiEje: 0,
  cercaOiPrisma: 0,
  cercaOiPrismaSelect: "",
  cercaOiEjePrisma: 0,
};

const initialRecetaIntermedia = {
  intermediaCheck: false,
  intermediaOdEsfera: 0,
  intermediaOdCilindro: 0,
  intermediaOdEje: 0,
  intermediaOdPrisma: 0,
  intermediaOdPrismaSelect: "",
  intermediaOdEjePrisma: 0,
  intermediaOiEsfera: 0,
  intermediaOiCilindro: 0,
  intermediaOiEje: 0,
  intermediaOiPrisma: 0,
  intermediaOiPrismaSelect: "",
  intermediaOiEjePrisma: 0,
};

const initialRecetaOtrosDatos = {
  medico: "",
  instituto: "",
  fechaReceta: new Date(),
};

const prismaOptions = [
  {
    id: "superior",
    descripcion: "Superior",
  },
  {
    id: "inferior",
    descripcion: "Inferior",
  },
  {
    id: "nasal",
    descripcion: "Nasal",
  },
  {
    id: "temporal",
    descripcion: "Temporal",
  },
];
//
// ################################################################################
// ANTEOJOS
//
const initialAnteojoAction = {
  cu: "new",
  idAnteojo: null,
  selectedAnteojo: true,
  codigoAnteojo: "",
};
//
// ################################################################################
// anteojos - anteojo nuevo
//
const initialAnteojoArmazonNuevo = {
  anteojoArmazonNuevoIdArmazon: "",
  anteojoArmazonNuevoCodigoArmazon: "",
  anteojoArmazonNuevoDescripcionArmazon: "",
  anteojoArmazonNuevoMarcaArmazon: "",
  anteojoArmazonNuevoModeloArmazon: "",
  anteojoArmazonNuevoCategoriaArmazon: "",
  anteojoArmazonNuevoMaterialArmazon: "",
  anteojoArmazonNuevoFormatoArmazon: "",
  anteojoArmazonNuevoCalibreArmazon: "",
  anteojoArmazonNuevoTipoArmazon: "",
  anteojoArmazonNuevoColorLenteArmazon: "",
  anteojoArmazonNuevoPrecioVentaArmazon: 0,
  anteojoArmazonNuevoPrecioVentaOriginalArmazon: 0,
  anteojoArmazonNuevoPorcentajeDescuentoArmazon: 0,
  anteojoArmazonNuevoPrecioVentaContadoArmazon: 0,
};
//
// ################################################################################
// anteojos - anteojo de cliente
//
const initialAnteojoArmazonCliente = {
  anteojoArmazonClienteDejaSuAnteojo: true,
  anteojoArmazonClienteDescripcion: "",
  anteojoArmazonClienteDistanciaHorizontal: 0,
  anteojoArmazonClienteDistanciaVertical: 0,
  anteojoArmazonClienteDistanciaDiagonal: 0,
  anteojoArmazonClienteDistanciaPuente: 0,
  anteojoArmazonClienteDistanciaMayor: 0,
  anteojoArmazonClientePerfil: "",
  anteojoArmazonClienteCaracteristica: "",
  anteojoArmazonClienteBase: "0",
};
//
// ################################################################################
// anteojos - cristales
//
const anteojoCristalesTipoAnteojoOptions = [
  {
    id: "monofocal-lejos",
    descripcion: "Monofocal - Lejos",
  },
  {
    id: "monofocal-cerca",
    descripcion: "Monofocal - Cerca",
  },
  {
    id: "monofocal-intermedia",
    descripcion: "Monofocal - Intermedia",
  },
  {
    id: "bifocal",
    descripcion: "Bifocal",
  },
  {
    id: "multifocal",
    descripcion: "Multifocal",
  },
  {
    id: "ocupacional",
    descripcion: "Ocupacional",
  },
];

const initialAnteojoCristales = {
  anteojoCristalesTipoAnteojo: "",
  anteojoCristalesTipoAnteojoDisabled: false,
  anteojoCristalesSelectedCristalOD: false,
  anteojoCristalesIdCristalProductoOD: "",
  anteojoCristalesIdBLCrDiametroOD: "",
  anteojoCristalesIdBLCrAdicionOD: "",
  anteojoCristalesDescripcionCristalOD: "",
  anteojoCristalesPrecioVentaCristalOD: 0,
  anteojoCristalesPrecioVentaOriginalCristalOD: 0,
  anteojoCristalesPorcentajeDescuentoCristalOD: 0,
  anteojoCristalesPrecioVentaContadoCristalOD: 0,
  anteojoCristalesSolictaDatosMonturaClienteOD: false,
  anteojoCristalesSelectedCristalOI: false,
  anteojoCristalesIdCristalProductoOI: "",
  anteojoCristalesIdBLCrDiametroOI: "",
  anteojoCristalesIdBLCrAdicionOI: "",
  anteojoCristalesDescripcionCristalOI: "",
  anteojoCristalesPrecioVentaCristalOI: 0,
  anteojoCristalesPrecioVentaOriginalCristalOI: 0,
  anteojoCristalesPorcentajeDescuentoCristalOI: 0,
  anteojoCristalesPrecioVentaContadoCristalOI: 0,
  anteojoCristalesSolictaDatosMonturaClienteOI: false,
  anteojoCristalesDistanciaPupilarOD: 0,
  anteojoCristalesDistanciaPupilarOI: 0,
  anteojoCristalesAlturaPupilarOD: 0,
  anteojoCristalesAlturaPupilarOI: 0,
  anteojoCristalesAlturaParpadoInferiorOD: 0,
  anteojoCristalesAlturaParpadoInferiorOI: 0,
};
//
// ################################################################################
// anteojos - tratamientos
//
const anteojoTratamientosOjoOptions = [
  {
    id: "ambos",
    descripcion: "Ambos",
  },
  {
    id: "derecho",
    descripcion: "Derecho",
  },
  {
    id: "izquierdo",
    descripcion: "Izquierdo",
  },
];

const initialAnteojoTratamiento = {
  anteojoTratamientoId: "",
  anteojoTratamientoOjo: "",
  anteojoTratamientoCodigo: "",
  anteojoTratamientoDescripcion: "",
  anteojoTratamientoPrecioVenta: 0,
  anteojoTratamientoPrecioVentaOriginal: 0,
  anteojoTratamientoPorcentajeDescuento: 0,
  anteojoTratamientoPrecioVentaContado: 0,
};
//
// ################################################################################
// anteojos - observaciones
//
const initialAnteojoObservaciones = {
  observaciones: "",
};
//
// ################################################################################
// ARREGLOS
//
const initialArregloAction = {
  cu: "new",
  idArreglo: null,
  selectedArreglo: true,
  codigoArreglo: "",
};
//
// ################################################################################
// arreglos - anteojos y cristales
//
const initialArregloAnteojoCristales = {
  arregloAnteojoCristalesDescripcion: "",
};
//
// ################################################################################
// arreglos - anteojo nuevo
//
const initialArregloArmazonNuevo = {
  arregloArmazonNuevoIdArmazon: "",
  arregloArmazonNuevoCodigoArmazon: "",
  arregloArmazonNuevoDescripcionArmazon: "",
  arregloArmazonNuevoMarcaArmazon: "",
  arregloArmazonNuevoModeloArmazon: "",
  arregloArmazonNuevoCategoriaArmazon: "",
  arregloArmazonNuevoMaterialArmazon: "",
  arregloArmazonNuevoFormatoArmazon: "",
  arregloArmazonNuevoCalibreArmazon: "",
  arregloArmazonNuevoTipoArmazon: "",
  arregloArmazonNuevoColorLenteArmazon: "",
  arregloArmazonNuevoPrecioVentaArmazon: 0,
  arregloArmazonNuevoPrecioVentaOriginalArmazon: 0,
  arregloArmazonNuevoPorcentajeDescuentoArmazon: 0,
  arregloArmazonNuevoPrecioVentaContadoArmazon: 0,
};
//
// ################################################################################
// arreglos - anteojo de cliente
//
const initialArregloArmazonCliente = {
  arregloArmazonClienteDescripcion: "",
};
//
// ################################################################################
// arreglos - servicios
//
const initialArregloServicio = {
  arregloServicioId: "",
  arregloServicioCodigo: "",
  arregloServicioDescripcion: "",
  arregloServicioPrecioVenta: 0,
  arregloServicioPrecioVentaOriginal: 0,
  arregloServicioPorcentajeDescuento: 0,
  arregloServicioPrecioVentaContado: 0,
  arregloServicioCantidad: 1,
  arregloServicioSubtotal: 0,
  arregloServicioSubtotalContado: 0,
};
//
// ################################################################################
// arreglos - tratamientos
//
const arregloTratamientosOjoOptions = [
  {
    id: "ambos",
    descripcion: "Ambos",
  },
  {
    id: "derecho",
    descripcion: "Derecho",
  },
  {
    id: "izquierdo",
    descripcion: "Izquierdo",
  },
];

const initialArregloTratamiento = {
  arregloTratamientoId: "",
  arregloTratamientoOjo: "",
  arregloTratamientoCodigo: "",
  arregloTratamientoDescripcion: "",
  arregloTratamientoPrecioVenta: 0,
  arregloTratamientoPrecioVentaOriginal: 0,
  arregloTratamientoPorcentajeDescuento: 0,
  arregloTratamientoPrecioVentaContado: 0,
};
//
// ################################################################################
// arreglos - fornituras
//
const initialArregloFornitura = {
  arregloFornituraId: "",
  arregloFornituraCodigo: "",
  arregloFornituraDescripcion: "",
  arregloFornituraPrecioVenta: 0,
  arregloFornituraPrecioVentaOriginal: 0,
  arregloFornituraPorcentajeDescuento: 0,
  arregloFornituraPrecioVentaContado: 0,
  arregloFornituraCantidad: 1,
  arregloFornituraSubtotal: 0,
  arregloFornituraSubtotalContado: 0,
};
//
// ################################################################################
// arreglos - observaciones
//
const initialArregloObservaciones = {
  observaciones: "",
};
//
// ################################################################################
// OTROS PRODUCTOS
//
const initialProducto = {
  productoSelected: true,
  productoId: "",
  productoCodigo: "",
  productoDescripcion: "",
  productoPrecioVenta: 0,
  productoPrecioVentaOriginal: 0,
  productoPorcentajeDescuento: 0,
  productoPrecioVentaContado: 0,
  productoCantidad: 1,
  productoSubtotal: 0,
  productoSubtotalContado: 0,
};
//
// ################################################################################
// LENTES DE CONTACTO
//
const initialLenteContactoAction = {
  cu: "new",
};

const initialLenteContacto = {
  lenteContactoSelected: true,
  lenteContactoId: "",
  lenteContactoCodigo: "",
  lenteContactoOjo: "",
  lenteContactoEsfera: 0,
  lenteContactoCilindro: 0,
  lenteContactoEje: "",
  lenteContactoCurvaBase: "",
  lenteContactoCurvaBaseValor: 0,
  lenteContactoDiametro: "",
  lenteContactoDiametroValor: 0,
  lenteContactoAdicion: "",
  lenteContactoProducto: "",
  lenteContactoProductoDescripcion: "",
  lenteContactoProductoMultifocal: "",
  lenteContactoPresentacion: "",
  lenteContactoPresentacionDescripcion: "",
  lenteContactoPrecioVenta: 0,
  lenteContactoPrecioVentaOriginal: 0,
  lenteContactoPorcentajeDescuento: 0,
  lenteContactoPrecioVentaContado: 0,
  lenteContactoCantidad: 1,
  lenteContactoSubtotal: 0,
  lenteContactoSubtotalContado: 0,
  lenteContactoObservaciones: "",
  lenteContactoCostoPesos: 0,
  lenteContactoVentaPorUnidad: "",
};
//
// ################################################################################
// FINALIZAR
//
const initialFinalizar = {
  subTotalGestionAtencion: 0,
  subTotalContadoGestionAtencion: 0,
  totalFinalGestionAtencion: 0,
  areaEntrega: localStorage.getItem("id_area_ventas"),
  fechaEntrega: new Date(),
  motivoVentaNoConcretada: "",
  descripcionMotivoVentaNoConcretada: "",
  detalleVentaNoConcretada: "",
  textoPresupuesto: "",
};
//
// ################################################################################
// COBRANZAS
//
const initialTotalesCobranza = {
  totalRecargo: 0,
  totalDescuento: 0,
  totalCobrado: 0,
  totalPendienteCobro: 0,
};
//
// ################################################################################
// ENTREGAS
//
const initialEntregaArticulos = {
  totalArticulosEntregados: 0,
  retiraTipoDocumento: "",
  retiraNumeroDocumento: "",
  retiraTipoNumeroDocumentoDisabled: false,
  retiraNombre: "",
  retiraApellido: "",
  retiraNombreApellidoDisabled: true,
  retiraObservaciones: "",
};
//
// ################################################################################
// ################################################################################
// ################################################################################
//
const GestionAtencionProvider = ({ children }) => {
  //
  // gestion comercial general
  //
  const [gaAction, setGaAction] = useState(initialGaAction);
  const [codigoGA, setCodigoGA] = useState("");
  const [sucursalGA, setSucursalGA] = useState("");
  const [usuarioGA, setUsuarioGA] = useState("");
  const [fechaCreacionGA, setFechaCreacionGA] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tabGestionAtencionValue, setTabGestionAtencionValue] = useState("cliente");
  //
  // CLIENTE
  //
  const [isSetClient, setIsSetClient] = useState(false);
  const [isNewClient, setIsNewClient] = useState(false);
  const [cliente, setCliente] = useState(initialCliente);
  const [disabledCliente, setDisabledCliente] = useState(false);
  //
  // RECETA
  //
  const [isRecetaError, setIsRecetaError] = useState(false);
  const [recetaLejos, setRecetaLejos] = useState(initialRecetaLejos);
  const [recetaLejosDisabled, setRecetaLejosDisabled] = useState(false);
  const [recetaCerca, setRecetaCerca] = useState(initialRecetaCerca);
  const [recetaCercaDisabled, setRecetaCercaDisabled] = useState(false);
  const [recetaIntermedia, setRecetaIntermedia] = useState(initialRecetaIntermedia);
  const [recetaIntermediaDisabled, setRecetaIntermediaDisabled] = useState(false);
  const [recetaOtrosDatos, setRecetaOtrosDatos] = useState(initialRecetaOtrosDatos);
  const [disabledReceta, setDisabledReceta] = useState(false);
  //
  // estado de error de valores de receta
  //
  const [errorLejosOdEsfera, setErrorLejosOdEsfera] = useState(false);
  const [errorLejosOdCilindro, setErrorLejosOdCilindro] = useState(false);
  const [errorLejosOdEje, setErrorLejosOdEje] = useState(false);
  const [errorLejosOdPrisma, setErrorLejosOdPrisma] = useState(false);
  const [errorLejosOdEjePrisma, setErrorLejosOdEjePrisma] = useState(false);
  const [errorLejosOiEsfera, setErrorLejosOiEsfera] = useState(false);
  const [errorLejosOiCilindro, setErrorLejosOiCilindro] = useState(false);
  const [errorLejosOiEje, setErrorLejosOiEje] = useState(false);
  const [errorLejosOiPrisma, setErrorLejosOiPrisma] = useState(false);
  const [errorLejosOiEjePrisma, setErrorLejosOiEjePrisma] = useState(false);
  const [errorCercaOdEsfera, setErrorCercaOdEsfera] = useState(false);
  const [errorCercaOdCilindro, setErrorCercaOdCilindro] = useState(false);
  const [errorCercaOdEje, setErrorCercaOdEje] = useState(false);
  const [errorCercaOdPrisma, setErrorCercaOdPrisma] = useState(false);
  const [errorCercaOdEjePrisma, setErrorCercaOdEjePrisma] = useState(false);
  const [errorCercaOiEsfera, setErrorCercaOiEsfera] = useState(false);
  const [errorCercaOiCilindro, setErrorCercaOiCilindro] = useState(false);
  const [errorCercaOiEje, setErrorCercaOiEje] = useState(false);
  const [errorCercaOiPrisma, setErrorCercaOiPrisma] = useState(false);
  const [errorCercaOiEjePrisma, setErrorCercaOiEjePrisma] = useState(false);
  const [errorIntermediaOdEsfera, setErrorIntermediaOdEsfera] = useState(false);
  const [errorIntermediaOdCilindro, setErrorIntermediaOdCilindro] = useState(false);
  const [errorIntermediaOdEje, setErrorIntermediaOdEje] = useState(false);
  const [errorIntermediaOdPrisma, setErrorIntermediaOdPrisma] = useState(false);
  const [errorIntermediaOdEjePrisma, setErrorIntermediaOdEjePrisma] = useState(false);
  const [errorIntermediaOiEsfera, setErrorIntermediaOiEsfera] = useState(false);
  const [errorIntermediaOiCilindro, setErrorIntermediaOiCilindro] = useState(false);
  const [errorIntermediaOiEje, setErrorIntermediaOiEje] = useState(false);
  const [errorIntermediaOiPrisma, setErrorIntermediaOiPrisma] = useState(false);
  const [errorIntermediaOiEjePrisma, setErrorIntermediaOiEjePrisma] = useState(false);
  //
  // ANTEOJOS
  //
  const [anteojoAction, setAnteojoAction] = useState(initialAnteojoAction);
  //
  // Anteojos - Anteojo
  //
  const [anteojoTabNuevoDeCliente, setAnteojoTabNuevoDeCliente] = useState(0);
  const [anteojoArmazonNuevo, setAnteojoArmazonNuevo] = useState(initialAnteojoArmazonNuevo);
  const [anteojoArmazonCliente, setAnteojoArmazonCliente] = useState(initialAnteojoArmazonCliente);
  //
  // Anteojos - Cristales
  //
  const [anteojoCristales, setAnteojoCristales] = useState(initialAnteojoCristales);
  const [totalCristales, setTotalCristales] = useState(0);
  const [totalCristalesContado, setTotalCristalesContado] = useState(0);
  //
  // Anteojos - Tratamientos
  //
  const [anteojoTratamiento, setAnteojoTratamiento] = useState(initialAnteojoTratamiento);
  const [anteojoTratamientosRows, setAnteojoTratamientosRows] = useState([]);
  const [totalAnteojoTratamientos, setTotalAnteojoTratamientos] = useState(0);
  const [totalAnteojoTratamientosContado, setTotalAnteojoTratamientosContado] = useState(0);
  //
  // Anteojos - Observaciones
  //
  const [anteojoObservaciones, setAnteojoObservaciones] = useState(initialAnteojoObservaciones);
  //
  // Anteojos - Totales
  //
  const [totalAnteojo, setTotalAnteojo] = useState(0);
  const [totalAnteojoContado, setTotalAnteojoContado] = useState(0);
  //
  // Anteojos de la GA
  //
  const [anteojos, setAnteojos] = useState([]);
  const [totalAnteojos, setTotalAnteojos] = useState(0);
  const [totalAnteojosContado, setTotalAnteojosContado] = useState(0);
  const [anteojosSelected, setAnteojosSelected] = useState([]);
  const [showCheckBoxesAnteojosRows, setShowCheckBoxesAnteojosRows] = useState(true);
  const [showActionsAnteojosRows, setShowActionsAnteojosRows] = useState(true);
  //
  // Anteojos - estado de accordions
  //
  const [expandedAccordionAnteojo, setExpandedAccordionAnteojo] = useState(false);
  const [disabledAccordionAnteojo, setDisabledAccordionAnteojo] = useState(false);
  const [expandedAccordionAnteojoAnteojo, setExpandedAccordionAnteojoAnteojo] = useState(false);
  const [expandedAccordionAnteojoCristales, setExpandedAccordionAnteojoCristales] = useState(false);
  const [expandedAccordionAnteojoTratamientos, setExpandedAccordionAnteojoTratamientos] =
    useState(false);
  const [expandedAccordionAnteojoObservaciones, setExpandedAccordionAnteojoObservaciones] =
    useState(false);
  //
  // ARREGLOS
  //
  const [arregloAction, setArregloAction] = useState(initialArregloAction);
  //
  // Arreglos - Anteojos y Cristales
  //
  const [arregloAnteojoCristales, setArregloAnteojoCristales] = useState(
    initialArregloAnteojoCristales
  );
  //
  // Arreglos - Pase de Cristales
  //
  const [arregloTabNuevoDeCliente, setArregloTabNuevoDeCliente] = useState(0);
  const [arregloArmazonNuevo, setArregloArmazonNuevo] = useState(initialArregloArmazonNuevo);
  const [arregloArmazonCliente, setArregloArmazonCliente] = useState(initialArregloArmazonCliente);
  //
  // Arreglos - Servicio
  //
  const [arregloServicio, setArregloServicio] = useState(initialArregloServicio);
  const [arregloServiciosRows, setArregloServiciosRows] = useState([]);
  const [totalArregloServicios, setTotalArregloServicios] = useState(0);
  useState(0);
  const [totalArregloServiciosContado, setTotalArregloServiciosContado] = useState(0);
  //
  // Arreglos - Tratamientos
  //
  const [arregloTratamiento, setArregloTratamiento] = useState(initialArregloTratamiento);
  const [arregloTratamientosRows, setArregloTratamientosRows] = useState([]);
  const [totalArregloTratamientos, setTotalArregloTratamientos] = useState(0);
  const [totalArregloTratamientosContado, setTotalArregloTratamientosContado] = useState(0);
  //
  // Arreglos - Fornituras
  //
  const [arregloFornitura, setArregloFornitura] = useState(initialArregloFornitura);
  const [arregloForniturasRows, setArregloForniturasRows] = useState([]);
  const [totalArregloFornituras, setTotalArregloFornituras] = useState(0);
  useState(0);
  const [totalArregloForniturasContado, setTotalArregloForniturasContado] = useState(0);
  //
  // Arreglos - Observaciones
  //
  const [arregloObservaciones, setArregloObservaciones] = useState(initialArregloObservaciones);
  //
  // Arreglos - Totales
  //
  const [totalArreglo, setTotalArreglo] = useState(0);
  const [totalArregloContado, setTotalArregloContado] = useState(0);
  //
  // Arreglos de la GA
  //
  const [arreglos, setArreglos] = useState([]);
  const [totalArreglos, setTotalArreglos] = useState(0);
  const [totalArreglosContado, setTotalArreglosContado] = useState(0);
  const [arreglosSelected, setArreglosSelected] = useState([]);
  const [showCheckBoxesArreglosRows, setShowCheckBoxesArreglosRows] = useState(true);
  const [showActionsArreglosRows, setShowActionsArreglosRows] = useState(true);
  //
  // Arreglos - estado de accordions
  //
  const [expandedAccordionArreglo, setExpandedAccordionArreglo] = useState(false);
  const [disabledAccordionArreglo, setDisabledAccordionArreglo] = useState(false);
  const [expandedAccordionArregloAnteojoCristales, setExpandedAccordionArregloAnteojoCristales] =
    useState(false);
  const [expandedAccordionArregloPaseCristales, setExpandedAccordionArregloPaseCristales] =
    useState(false);
  const [expandedAccordionArregloServicios, setExpandedAccordionArregloServicios] = useState(false);
  const [expandedAccordionArregloTratamientos, setExpandedAccordionArregloTratamientos] =
    useState(false);
  const [expandedAccordionArregloFornituras, setExpandedAccordionArregloFornituras] =
    useState(false);
  const [expandedAccordionArregloObservaciones, setExpandedAccordionArregloObservaciones] =
    useState(false);
  //
  // OTROS PRODUCTOS
  //
  const [producto, setProducto] = useState(initialProducto);
  const [productosRows, setProductosRows] = useState([]);
  const [totalProductos, setTotalProductos] = useState(0);
  const [totalProductosContado, setTotalProductosContado] = useState(0);
  const [productosSelected, setProductosSelected] = useState([]);
  const [showCheckBoxesProductosRows, setShowCheckBoxesProductosRows] = useState(true);
  const [showActionsProductosRows, setShowActionsProductosRows] = useState(true);
  //
  // Otros productos - estado de accordions
  //
  const [expandedAccordionProducto, setExpandedAccordionProducto] = useState(false);
  const [disabledAccordionProducto, setDisabledAccordionProducto] = useState(false);
  //
  // LENTES DE CONTACTO
  //
  const [lenteContactoOjoOptions, setLenteContactoOjoOptions] = useState([]);
  const [lenteContactoAction, setLenteContactoAction] = useState(initialLenteContactoAction);
  const [lenteContacto, setLenteContacto] = useState(initialLenteContacto);
  const [lentesContactoRows, setLentesContactoRows] = useState([]);
  const [totalLentesContacto, setTotalLentesContacto] = useState(0);
  const [totalLentesContactoContado, setTotalLentesContactoContado] = useState(0);
  const [lentesContactoSelected, setLentesContactoSelected] = useState([]);
  useState(true);
  const [showCheckBoxesLentesContactoRows, setShowCheckBoxesLentesContactoRows] = useState(true);
  const [showActionsLentesContactoRows, setShowActionsLentesContactoRows] = useState(true);
  const [disabledDatosLenteContacto, setDisabledDatosLenteContacto] = useState(true);
  //
  // Lentes de contacto - estado de accordions
  //
  const [expandedAccordionLenteContacto, setExpandedAccordionLenteContacto] = useState(false);
  const [disabledAccordionLenteContacto, setDisabledAccordionLenteContacto] = useState(false);
  //
  // FINALIZAR
  //
  const [finalizar, setFinalizar] = useState(initialFinalizar);
  const [particularObraSocial, setParticularObraSocial] = useState("particular");
  const [disabledGestionParticularObraSocial, setDisabledGestionParticularObraSocial] =
    useState(false);
  const [disabledTotalFinalGestionAtencion, setDisabledTotalFinalGestionAtencion] = useState(true);
  const [disabledConfirmarGestionAtencion, setDisabledConfirmarGestionAtencion] = useState(false);
  const [disabledModificarGestionAtencion, setDisabledModificarGestionAtencion] = useState(true);
  const [gestionAtencionConfirmada, setGestionAtencionConfirmada] = useState(false);
  const [ventaConcretadaNoConcretada, setVentaConcretadaNoConcretada] =
    useState("venta-concretada");
  const [disabledVentaConcretadaNoConcretada, setDisabledVentaConcretadaNoConcretada] =
    useState(true);
  const [emiteNoEmitePresupuesto, setEmiteNoEmitePresupuesto] = useState("emite-presupuesto");
  useState(false);
  const [disabledGuardarGA, setDisabledGuardarGA] = useState(true);
  const [showImportesContado, setShowImportesContado] = useState(true);
  const [valueACAreaEntrega, setvalueACAreaEntrega] = useState({
    id: localStorage.getItem("id_area_ventas"),
    descripcion: localStorage.getItem("descripcion_area_ventas"),
  });
  const [inputvalueACAreaEntrega, setInputvalueACAreaEntrega] = useState("");

  //
  // COBRANZAS
  //
  const [totalesCobranza, setTotalesCobranza] = useState(initialTotalesCobranza);
  const [cobranzasRows, setCobranzasRows] = useState([]);
  const [showTabCobranzas, setShowTabCobranzas] = useState(false);

  // ENTREGAS
  const [articulosParaEntregarRows, setArticulosParaEntregarRows] = useState([]);
  const [entregaArticulos, setEntregaArticulos] = useState(initialEntregaArticulos);
  const [entregasArticulosRows, setEntregasArticulosRows] = useState([]);
  const [showTabEntregaArticulos, setShowTabEntregaArticulos] = useState(false);

  //
  // ################################################################################
  // cuando hay algun error en los valores de la receta
  //
  useEffect(() => {
    if (
      errorLejosOdEsfera ||
      errorLejosOdCilindro ||
      errorLejosOdEje ||
      errorLejosOdPrisma ||
      errorLejosOdEjePrisma ||
      errorLejosOiEsfera ||
      errorLejosOiCilindro ||
      errorLejosOiEje ||
      errorLejosOiPrisma ||
      errorLejosOiEjePrisma ||
      errorCercaOdEsfera ||
      errorCercaOdCilindro ||
      errorCercaOdEje ||
      errorCercaOdPrisma ||
      errorCercaOdEjePrisma ||
      errorCercaOiEsfera ||
      errorCercaOiCilindro ||
      errorCercaOiEje ||
      errorCercaOiPrisma ||
      errorCercaOiEjePrisma ||
      errorIntermediaOdEsfera ||
      errorIntermediaOdCilindro ||
      errorIntermediaOdEje ||
      errorIntermediaOdPrisma ||
      errorIntermediaOdEjePrisma ||
      errorIntermediaOiEsfera ||
      errorIntermediaOiCilindro ||
      errorIntermediaOiEje ||
      errorIntermediaOiPrisma ||
      errorIntermediaOiEjePrisma
    ) {
      setIsRecetaError(true);
    } else {
      setIsRecetaError(false);
    }
  }, [
    errorLejosOdEsfera,
    errorLejosOdCilindro,
    errorLejosOdEje,
    errorLejosOdPrisma,
    errorLejosOdEjePrisma,
    errorLejosOiEsfera,
    errorLejosOiCilindro,
    errorLejosOiEje,
    errorLejosOiPrisma,
    errorLejosOiEjePrisma,
    errorCercaOdEsfera,
    errorCercaOdCilindro,
    errorCercaOdEje,
    errorCercaOdPrisma,
    errorCercaOdEjePrisma,
    errorCercaOiEsfera,
    errorCercaOiCilindro,
    errorCercaOiEje,
    errorCercaOiPrisma,
    errorCercaOiEjePrisma,
    errorIntermediaOdEsfera,
    errorIntermediaOdCilindro,
    errorIntermediaOdEje,
    errorIntermediaOdPrisma,
    errorIntermediaOdEjePrisma,
    errorIntermediaOiEsfera,
    errorIntermediaOiCilindro,
    errorIntermediaOiEje,
    errorIntermediaOiPrisma,
    errorIntermediaOiEjePrisma,
  ]);
  //
  // ################################################################################
  // cuando el usuario selecciona un tipo de anteojo o bien cuando el usuario agrega, actualiza o quita un anteojo
  // deshabilito las correcciones que habilitan el tipo de anteojo seleccionado o el tipo de anteojo de los
  // anteojos en la tabla
  // esto para evitar que el usuario seleccione un tipo de anteojo y luego modifique la receta quitando la correccion
  // que habilitaba el tipo de anteojo
  //
  useEffect(() => {
    setRecetaLejosDisabled(false);
    setRecetaCercaDisabled(false);
    setRecetaIntermediaDisabled(false);

    switch (anteojoCristales.anteojoCristalesTipoAnteojo) {
      case "monofocal-cerca":
        setRecetaCercaDisabled(true);
        break;
      case "monofocal-lejos":
        setRecetaLejosDisabled(true);
        break;
      case "monofocal-intermedia":
        setRecetaIntermediaDisabled(true);
        break;
      case "bifocal":
        setRecetaLejosDisabled(true);
        setRecetaCercaDisabled(true);
        break;
      case "multifocal":
        setRecetaLejosDisabled(true);
        setRecetaCercaDisabled(true);
        break;
      case "ocupacional":
        setRecetaCercaDisabled(true);
        setRecetaIntermediaDisabled(true);
        break;
      default:
    }

    anteojos.forEach((item) => {
      switch (item.cristalesTipoAnteojo) {
        case "monofocal-cerca":
          setRecetaCercaDisabled(true);
          break;
        case "monofocal-lejos":
          setRecetaLejosDisabled(true);
          break;
        case "monofocal-intermedia":
          setRecetaIntermediaDisabled(true);
          break;
        case "bifocal":
          setRecetaLejosDisabled(true);
          setRecetaCercaDisabled(true);
          break;
        case "multifocal":
          setRecetaLejosDisabled(true);
          setRecetaCercaDisabled(true);
          break;
        case "ocupacional":
          setRecetaCercaDisabled(true);
          setRecetaIntermediaDisabled(true);
          break;
        default:
      }
    });
  }, [anteojoCristales.anteojoCristalesTipoAnteojo, anteojos]);
  //
  // ################################################################################
  // cada vez que el usuario agrega, modifica, quita o selecciona un anteojo, un arreglo o un producto,
  // calculo el total de la ga
  //
  useEffect(() => {
    calcularTotalesGA();
  }, [anteojos, arreglos, productosRows, lentesContactoRows]);
  //
  // ################################################################################
  //
  const handleChangeCliente = (e) => {
    const { name, type, checked, value } = e.target;
    setCliente((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  //
  // ################################################################################
  //
  const handleChangeClienteFechaNacimiento = (parFechaNacimiento) => {
    setCliente({
      ...cliente,
      fechaNacimiento: parFechaNacimiento,
      edadActual: calculateDifferenceYears(parFechaNacimiento),
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRecetaLejos = (e) => {
    setRecetaLejos({
      ...recetaLejos,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRecetaCerca = (e) => {
    setRecetaCerca({
      ...recetaCerca,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRecetaIntermedia = (e) => {
    setRecetaIntermedia({
      ...recetaIntermedia,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRecetaOtrosDatos = (e) => {
    setRecetaOtrosDatos({
      ...recetaOtrosDatos,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRecetaOtrosDatosFechaReceta = (fechaReceta) => {
    setRecetaOtrosDatos({
      ...recetaOtrosDatos,
      fechaReceta: fechaReceta,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeAnteojoArmazonNuevo = (e) => {
    setAnteojoArmazonNuevo({
      ...anteojoArmazonNuevo,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeAnteojoArmazonCliente = (e) => {
    setAnteojoArmazonCliente({
      ...anteojoArmazonCliente,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeAnteojoCristales = (e) => {
    setAnteojoCristales({
      ...anteojoCristales,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeAnteojoTratamiento = (e) => {
    setAnteojoTratamiento({
      ...anteojoTratamiento,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeAnteojoObservaciones = (e) => {
    setAnteojoObservaciones({
      ...anteojoObservaciones,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const limpiaCliente = () => {
    setCliente(initialCliente);
    setIsSetClient(false);
    setIsNewClient(false);
    setDisabledCliente(false);
  };
  //
  // ################################################################################
  //
  const limpiaReceta = () => {
    setIsRecetaError(false);
    setRecetaLejos(initialRecetaLejos);
    setRecetaCerca(initialRecetaCerca);
    setRecetaIntermedia(initialRecetaIntermedia);
    setRecetaOtrosDatos(initialRecetaOtrosDatos);
    setErrorLejosOdEsfera(false);
    setErrorLejosOdCilindro(false);
    setErrorLejosOdEje(false);
    setErrorLejosOdPrisma(false);
    setErrorLejosOdEjePrisma(false);
    setErrorLejosOiEsfera(false);
    setErrorLejosOiCilindro(false);
    setErrorLejosOiEje(false);
    setErrorLejosOiPrisma(false);
    setErrorLejosOiEjePrisma(false);
    setErrorCercaOdEsfera(false);
    setErrorCercaOdCilindro(false);
    setErrorCercaOdEje(false);
    setErrorCercaOdPrisma(false);
    setErrorCercaOdEjePrisma(false);
    setErrorCercaOiEsfera(false);
    setErrorCercaOiCilindro(false);
    setErrorCercaOiEje(false);
    setErrorCercaOiPrisma(false);
    setErrorCercaOiEjePrisma(false);
    setErrorIntermediaOdEsfera(false);
    setErrorIntermediaOdCilindro(false);
    setErrorIntermediaOdEje(false);
    setErrorIntermediaOdPrisma(false);
    setErrorIntermediaOdEjePrisma(false);
    setErrorIntermediaOiEsfera(false);
    setErrorIntermediaOiCilindro(false);
    setErrorIntermediaOiEje(false);
    setErrorIntermediaOiPrisma(false);
    setErrorIntermediaOiEjePrisma(false);
    setDisabledReceta(false);
  };
  //
  // ################################################################################
  // metodos de anteojos
  // ################################################################################
  //
  // ################################################################################
  //
  const limpiaAnteojo = () => {
    setAnteojoAction(initialAnteojoAction);
    setAnteojoTabNuevoDeCliente(0);
    setAnteojoArmazonNuevo(initialAnteojoArmazonNuevo);
    setAnteojoArmazonCliente(initialAnteojoArmazonCliente);
    setAnteojoCristales(initialAnteojoCristales);
    setTotalCristales(0);
    setTotalCristalesContado(0);
    setAnteojoTratamiento(initialAnteojoTratamiento);
    setAnteojoTratamientosRows([]);
    setTotalAnteojoTratamientos(0);
    setTotalAnteojoTratamientosContado(0);
    setAnteojoObservaciones(initialAnteojoObservaciones);
    setTotalAnteojo(0);
    setTotalAnteojoContado(0);
    setExpandedAccordionAnteojo(false);
    setExpandedAccordionAnteojoAnteojo(false);
    setExpandedAccordionAnteojoCristales(false);
    setExpandedAccordionAnteojoTratamientos(false);
    setExpandedAccordionAnteojoObservaciones(false);
    setDisabledAccordionAnteojo(gaAction.cu === "view" ? true : false);
    setShowCheckBoxesAnteojosRows(gaAction.cu === "view" ? false : true);
    setShowActionsAnteojosRows(true);
  };
  //
  // ################################################################################
  //
  const guardarAnteojoEnTablaAnteojos = () => {
    let _tratamientos = anteojoTratamientosRows;

    let _anteojo = {
      id: anteojoAction.cu === "new" ? uuidv4() : anteojoAction.idAnteojo,
      selectedAnteojo: anteojoAction.cu === "new" ? true : anteojoAction.selectedAnteojo,
      codigoAnteojo: anteojoAction.cu === "new" ? '---' : anteojoAction.codigoAnteojo,
      armazonNuevoIdArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoIdArmazon,
      armazonNuevoCodigoArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoCodigoArmazon,
      armazonNuevoDescripcionArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoDescripcionArmazon,
      armazonNuevoMarcaArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoMarcaArmazon,
      armazonNuevoModeloArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoModeloArmazon,
      armazonNuevoCategoriaArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoCategoriaArmazon,
      armazonNuevoMaterialArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoMaterialArmazon,
      armazonNuevoFormatoArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoFormatoArmazon,
      armazonNuevoCalibreArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoCalibreArmazon,
      armazonNuevoTipoArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoTipoArmazon,
      armazonNuevoColorLenteArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoColorLenteArmazon,
      armazonNuevoPrecioVentaArmazon: anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaArmazon,
      armazonNuevoPrecioVentaOriginalArmazon:
        anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaOriginalArmazon,
      armazonNuevoPorcentajeDescuentoArmazon:
        anteojoArmazonNuevo.anteojoArmazonNuevoPorcentajeDescuentoArmazon,
      armazonNuevoPrecioVentaContadoArmazon:
        anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaContadoArmazon,
      armazonClienteDescripcion: anteojoArmazonCliente.anteojoArmazonClienteDescripcion,
      armazonClienteDistanciaHorizontal: parseInt(
        +anteojoArmazonCliente.anteojoArmazonClienteDistanciaHorizontal
      ),
      armazonClienteDistanciaVertical: anteojoArmazonCliente.anteojoArmazonClienteDistanciaVertical,
      armazonClienteDistanciaDiagonal: anteojoArmazonCliente.anteojoArmazonClienteDistanciaDiagonal,
      armazonClienteDistanciaPuente: anteojoArmazonCliente.anteojoArmazonClienteDistanciaPuente,
      armazonClienteDistanciaMayor: anteojoArmazonCliente.anteojoArmazonClienteDistanciaMayor,
      armazonClientePerfil: anteojoArmazonCliente.anteojoArmazonClientePerfil,
      armazonClienteCaracteristica: anteojoArmazonCliente.anteojoArmazonClienteCaracteristica,
      armazonClienteBase: anteojoArmazonCliente.anteojoArmazonClienteBase,
      armazonClienteDejaSuAnteojo: anteojoArmazonCliente.anteojoArmazonClienteDejaSuAnteojo,
      anteojoTableDescripcion:
        anteojoArmazonNuevo.anteojoArmazonNuevoCodigoArmazon !== ""
          ? anteojoArmazonNuevo.anteojoArmazonNuevoCodigoArmazon +
          " - " +
          anteojoArmazonNuevo.anteojoArmazonNuevoMarcaArmazon +
          " - " +
          anteojoArmazonNuevo.anteojoArmazonNuevoModeloArmazon
          : "ANTEOJO DE CLIENTE",
      cristalesTipoAnteojo: anteojoCristales.anteojoCristalesTipoAnteojo,
      cristalIdCristalProductoOD: anteojoCristales.anteojoCristalesIdCristalProductoOD,
      cristalIdBlCrDiametroOD: anteojoCristales.anteojoCristalesIdBLCrDiametroOD,
      cristalIdBlCrAdicionOD: anteojoCristales.anteojoCristalesIdBLCrAdicionOD,
      cristalDescripcionOD: anteojoCristales.anteojoCristalesDescripcionCristalOD,
      cristalPrecioVentaOD: anteojoCristales.anteojoCristalesPrecioVentaCristalOD,
      cristalPrecioVentaOriginalOD: anteojoCristales.anteojoCristalesPrecioVentaOriginalCristalOD,
      cristalPorcentajeDescuentoOD: anteojoCristales.anteojoCristalesPorcentajeDescuentoCristalOD,
      cristalPrecioVentaContadoOD: anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOD,
      cristalSolictaDatosMonturaClienteOD:
        anteojoCristales.anteojoCristalesSolictaDatosMonturaClienteOD,
      cristalIdCristalProductoOI: anteojoCristales.anteojoCristalesIdCristalProductoOI,
      cristalIdBlCrDiametroOI: anteojoCristales.anteojoCristalesIdBLCrDiametroOI,
      cristalIdBlCrAdicionOI: anteojoCristales.anteojoCristalesIdBLCrAdicionOI,
      cristalDescripcionOI: anteojoCristales.anteojoCristalesDescripcionCristalOI,
      cristalPrecioVentaOI: anteojoCristales.anteojoCristalesPrecioVentaCristalOI,
      cristalPrecioVentaOriginalOI: anteojoCristales.anteojoCristalesPrecioVentaOriginalCristalOI,
      cristalPorcentajeDescuentoOI: anteojoCristales.anteojoCristalesPorcentajeDescuentoCristalOI,
      cristalPrecioVentaContadoOI: anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOI,
      cristalSolictaDatosMonturaClienteOI:
        anteojoCristales.anteojoCristalesSolictaDatosMonturaClienteOI,
      cristalDistanciaPupilarOD: anteojoCristales.anteojoCristalesDistanciaPupilarOD,
      cristalDistanciaPupilarOI: anteojoCristales.anteojoCristalesDistanciaPupilarOI,
      cristalAlturaPupilarOD: anteojoCristales.anteojoCristalesAlturaPupilarOD,
      cristalAlturaPupilarOI: anteojoCristales.anteojoCristalesAlturaPupilarOI,
      cristalAlturaParpadoInferiorOD: anteojoCristales.anteojoCristalesAlturaParpadoInferiorOD,
      cristalAlturaParpadoInferiorOI: anteojoCristales.anteojoCristalesAlturaParpadoInferiorOI,
      tratamientos: _tratamientos,
      observaciones: anteojoObservaciones.observaciones,
      totalAnteojo: totalAnteojo,
      totalAnteojoContado: totalAnteojoContado,
    };

    if (anteojoAction.cu === "new") {
      setAnteojos([...anteojos, _anteojo]);
      setAnteojosSelected([...anteojosSelected, _anteojo.id]);
    } else {
      setAnteojos(anteojos.map((item) => (item.id === anteojoAction.idAnteojo ? _anteojo : item)));
    }
    limpiaAnteojo();
  };
  //
  // ################################################################################
  //
  const obtenerAnteojo = (parRow, parAction) => {
    setAnteojoAction({
      cu: parAction,
      idAnteojo: parRow.id,
      selectedAnteojo: parRow.selectedAnteojo,
      codigoAnteojo: parRow.codigoAnteojo,
    });

    const _anteojo = anteojos.find((anteojo) => anteojo.id === parRow.id);

    setAnteojoTabNuevoDeCliente(_anteojo.armazonNuevoIdArmazon !== "" ? 0 : 1);

    let _anteojoArmazonNuevo = {
      anteojoArmazonNuevoIdArmazon: _anteojo.armazonNuevoIdArmazon,
      anteojoArmazonNuevoCodigoArmazon: _anteojo.armazonNuevoCodigoArmazon,
      anteojoArmazonNuevoDescripcionArmazon: _anteojo.armazonNuevoDescripcionArmazon,
      anteojoArmazonNuevoMarcaArmazon: _anteojo.armazonNuevoMarcaArmazon,
      anteojoArmazonNuevoModeloArmazon: _anteojo.armazonNuevoModeloArmazon,
      anteojoArmazonNuevoCategoriaArmazon: _anteojo.armazonNuevoCategoriaArmazon,
      anteojoArmazonNuevoMaterialArmazon: _anteojo.armazonNuevoMaterialArmazon,
      anteojoArmazonNuevoFormatoArmazon: _anteojo.armazonNuevoFormatoArmazon,
      anteojoArmazonNuevoCalibreArmazon: _anteojo.armazonNuevoCalibreArmazon,
      anteojoArmazonNuevoTipoArmazon: _anteojo.armazonNuevoTipoArmazon,
      anteojoArmazonNuevoColorLenteArmazon: _anteojo.armazonNuevoColorLenteArmazon,
      anteojoArmazonNuevoPrecioVentaArmazon: _anteojo.armazonNuevoPrecioVentaArmazon,
      anteojoArmazonNuevoPrecioVentaOriginalArmazon:
        _anteojo.armazonNuevoPrecioVentaOriginalArmazon,
      anteojoArmazonNuevoPorcentajeDescuentoArmazon:
        _anteojo.armazonNuevoPorcentajeDescuentoArmazon,
      anteojoArmazonNuevoPrecioVentaContadoArmazon: _anteojo.armazonNuevoPrecioVentaContadoArmazon,
    };
    setAnteojoArmazonNuevo(_anteojoArmazonNuevo);

    let _anteojoArmazonCliente = {
      anteojoArmazonClienteDescripcion: _anteojo.armazonClienteDescripcion,
      anteojoArmazonClienteDistanciaHorizontal: _anteojo.armazonClienteDistanciaHorizontal,
      anteojoArmazonClienteDistanciaVertical: _anteojo.armazonClienteDistanciaVertical,
      anteojoArmazonClienteDistanciaDiagonal: _anteojo.armazonClienteDistanciaDiagonal,
      anteojoArmazonClienteDistanciaPuente: _anteojo.armazonClienteDistanciaPuente,
      anteojoArmazonClienteDistanciaMayor: _anteojo.armazonClienteDistanciaMayor,
      anteojoArmazonClientePerfil: _anteojo.armazonClientePerfil,
      anteojoArmazonClienteCaracteristica: _anteojo.armazonClienteCaracteristica,
      anteojoArmazonClienteBase: _anteojo.armazonClienteBase,
      anteojoArmazonClienteDejaSuAnteojo: _anteojo.armazonClienteDejaSuAnteojo,
    };
    setAnteojoArmazonCliente(_anteojoArmazonCliente);

    let _anteojoCristales = {
      anteojoCristalesTipoAnteojoDisabled: true,
      anteojoCristalesTipoAnteojo: _anteojo.cristalesTipoAnteojo,
      anteojoCristalesSelectedCristalOD: _anteojo.cristalDescripcionOD ? true : false,
      anteojoCristalesIdCristalProductoOD: _anteojo.cristalIdCristalProductoOD,
      anteojoCristalesIdBLCrDiametroOD: _anteojo.cristalIdBlCrDiametroOD,
      anteojoCristalesIdBLCrAdicionOD: _anteojo.cristalIdBlCrAdicionOD,
      anteojoCristalesDescripcionCristalOD: _anteojo.cristalDescripcionOD,
      anteojoCristalesPrecioVentaCristalOD: _anteojo.cristalPrecioVentaOD,
      anteojoCristalesPrecioVentaOriginalCristalOD: _anteojo.cristalPrecioVentaOriginalOD,
      anteojoCristalesPorcentajeDescuentoCristalOD: _anteojo.cristalPorcentajeDescuentoOD,
      anteojoCristalesPrecioVentaContadoCristalOD: _anteojo.cristalPrecioVentaContadoOD,
      anteojoCristalesSolictaDatosMonturaClienteOD: _anteojo.cristalSolictaDatosMonturaClienteOD,
      anteojoCristalesSelectedCristalOI: _anteojo.cristalDescripcionOI ? true : false,
      anteojoCristalesIdCristalProductoOI: _anteojo.cristalIdCristalProductoOI,
      anteojoCristalesIdBLCrDiametroOI: _anteojo.cristalIdBlCrDiametroOI,
      anteojoCristalesIdBLCrAdicionOI: _anteojo.cristalIdBlCrAdicionOI,
      anteojoCristalesDescripcionCristalOI: _anteojo.cristalDescripcionOI,
      anteojoCristalesPrecioVentaCristalOI: _anteojo.cristalPrecioVentaOI,
      anteojoCristalesPrecioVentaOriginalCristalOI: _anteojo.cristalPrecioVentaOriginalOI,
      anteojoCristalesPorcentajeDescuentoCristalOI: _anteojo.cristalPorcentajeDescuentoOI,
      anteojoCristalesPrecioVentaContadoCristalOI: _anteojo.cristalPrecioVentaContadoOI,
      anteojoCristalesSolictaDatosMonturaClienteOI: _anteojo.cristalSolictaDatosMonturaClienteOI,
      anteojoCristalesDistanciaPupilarOD: _anteojo.cristalDistanciaPupilarOD,
      anteojoCristalesDistanciaPupilarOI: _anteojo.cristalDistanciaPupilarOI,
      anteojoCristalesAlturaPupilarOD: _anteojo.cristalAlturaPupilarOD,
      anteojoCristalesAlturaPupilarOI: _anteojo.cristalAlturaPupilarOI,
      anteojoCristalesAlturaParpadoInferiorOD: _anteojo.cristalAlturaParpadoInferiorOD,
      anteojoCristalesAlturaParpadoInferiorOI: _anteojo.cristalAlturaParpadoInferiorOI,
    };
    setAnteojoCristales(_anteojoCristales);

    let _anteojoTratamientosRows = [];
    if (_anteojo.tratamientos.length > 0) {
      _anteojoTratamientosRows = _anteojo.tratamientos.map((item) => {
        return {
          id: item.id,
          anteojoTratamientoId: item.anteojoTratamientoId,
          anteojoTratamientoOjo: item.anteojoTratamientoOjo,
          anteojoTratamientoCodigo: item.anteojoTratamientoCodigo,
          anteojoTratamientoDescripcion: item.anteojoTratamientoDescripcion,
          anteojoTratamientoPrecioVenta: item.anteojoTratamientoPrecioVenta,
          anteojoTratamientoPrecioVentaOriginal: item.anteojoTratamientoPrecioVentaOriginal,
          anteojoTratamientoPorcentajeDescuento: item.anteojoTratamientoPorcentajeDescuento,
          anteojoTratamientoPrecioVentaContado: item.anteojoTratamientoPrecioVentaContado,
        };
      });
    }
    setAnteojoTratamientosRows(_anteojoTratamientosRows);

    let _anteojoObservaciones = {
      observaciones: _anteojo.observaciones,
    };
    setAnteojoObservaciones(_anteojoObservaciones);

    // expando los accordions que corresponda

    // setDisabledAccordionAnteojo(false);
    setExpandedAccordionAnteojo(true);
    setExpandedAccordionAnteojoAnteojo(true);
    setExpandedAccordionAnteojoCristales(true);
    if (_anteojo.tratamientos.length > 0) {
      setExpandedAccordionAnteojoTratamientos(true);
    }
    if (_anteojo.observaciones) {
      setExpandedAccordionAnteojoObservaciones(true);
    }
  };
  //
  // ################################################################################
  //
  const quitarAnteojo = (parRow) => {
    let _anteojos = anteojos.filter((anteojo) => anteojo.id !== parRow.id);
    let _anteojosSelected = [];

    _anteojos.forEach((item) => {
      if (item.selectedAnteojo) {
        _anteojosSelected.push(item.id);
      }
    });

    setAnteojos(_anteojos);
    setAnteojosSelected(_anteojosSelected);
  };
  //
  // ################################################################################
  //
  const seleccionarAnteojos = (parAnteojosSelected) => {
    let _anteojos = [];
    if (parAnteojosSelected.length === 0) {
      // si no hay anteojos seleccionados
      anteojos.forEach((item) => {
        item.selectedAnteojo = false;
        _anteojos.push(item);
      });
    } else {
      // si hay anteojos seleccionados
      anteojos.forEach((item) => {
        if (parAnteojosSelected.includes(item.id)) {
          // si el anteojo actual esta seleccionado
          item.selectedAnteojo = true;
        } else {
          // si el anteojo actual esta seleccionado
          item.selectedAnteojo = false;
        }
        _anteojos.push(item);
      });
    }
    setAnteojos(_anteojos);
    setAnteojosSelected(parAnteojosSelected);
  };
  //
  // ################################################################################
  // calculo totales cuando en el anteojo el usuario selecciona o borra el anteojo nuevo,
  // selecciona o quita un cristal, agrega o quita un tratamiento
  useEffect(() => {
    let _totalCristales =
      anteojoCristales.anteojoCristalesPrecioVentaCristalOD +
      anteojoCristales.anteojoCristalesPrecioVentaCristalOI;
    setTotalCristales(_totalCristales);

    let _totalCristalesContado =
      anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOD +
      anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOI;
    setTotalCristalesContado(_totalCristalesContado);

    let _totalTratamientos = 0;
    anteojoTratamientosRows.forEach((item) => {
      _totalTratamientos += item.anteojoTratamientoPrecioVenta;
    });
    setTotalAnteojoTratamientos(_totalTratamientos);

    let _totalTratamientosContado = 0;
    anteojoTratamientosRows.forEach((item) => {
      _totalTratamientosContado += item.anteojoTratamientoPrecioVentaContado;
    });
    setTotalAnteojoTratamientosContado(_totalTratamientosContado);

    setTotalAnteojo(
      anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaArmazon +
      totalCristales +
      totalAnteojoTratamientos
    );

    setTotalAnteojoContado(
      anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaContadoArmazon +
      totalCristalesContado +
      totalAnteojoTratamientosContado
    );
  }, [
    anteojoCristales.anteojoCristalesPrecioVentaCristalOD,
    anteojoCristales.anteojoCristalesPrecioVentaCristalOI,
    anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOD,
    anteojoCristales.anteojoCristalesPrecioVentaContadoCristalOI,
    anteojoTratamientosRows,
    anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaArmazon,
    anteojoArmazonNuevo.anteojoArmazonNuevoPrecioVentaContadoArmazon,
    totalCristales,
    totalCristalesContado,
    totalAnteojoTratamientos,
    totalAnteojoTratamientosContado,
  ]);
  //
  // ################################################################################
  // metodos de arreglos
  // ################################################################################
  //
  const limpiaArreglo = () => {
    setArregloAction(initialArregloAction);
    setArregloAnteojoCristales(initialArregloAnteojoCristales);
    setArregloTabNuevoDeCliente(0);
    setArregloArmazonNuevo(initialArregloArmazonNuevo);
    setArregloArmazonCliente(initialArregloArmazonCliente);
    setArregloServicio(initialArregloServicio);
    setArregloServiciosRows([]);
    setTotalArregloServicios(0);
    setTotalArregloServiciosContado(0);
    setArregloTratamiento(initialArregloTratamiento);
    setArregloTratamientosRows([]);
    setTotalArregloTratamientos(0);
    setTotalArregloTratamientosContado(0);
    setArregloFornitura(initialArregloFornitura);
    setArregloForniturasRows([]);
    setTotalArregloFornituras(0);
    setTotalArregloForniturasContado(0);
    setArregloObservaciones(initialArregloObservaciones);
    setTotalArreglo(0);
    setTotalArregloContado(0);
    setExpandedAccordionArreglo(false);
    setExpandedAccordionArregloAnteojoCristales(false);
    setExpandedAccordionArregloPaseCristales(false);
    setExpandedAccordionArregloServicios(false);
    setExpandedAccordionArregloTratamientos(false);
    setExpandedAccordionArregloFornituras(false);
    setExpandedAccordionArregloObservaciones(false);
    setDisabledAccordionArreglo(gaAction.cu === "view" ? true : false);
    setShowCheckBoxesArreglosRows(gaAction.cu === "view" ? false : true);
    setShowActionsArreglosRows(true);
  };
  //
  // ################################################################################
  //
  const guardarArregloEnTablaArreglos = () => {
    let _servicios = arregloServiciosRows;
    let _tratamientos = arregloTratamientosRows;
    let _fornituras = arregloForniturasRows;

    let _arreglo = {
      id: arregloAction.cu === "new" ? uuidv4() : arregloAction.idArreglo,
      selectedArreglo: arregloAction.cu === "new" ? true : arregloAction.selectedArreglo,
      codigoArreglo: arregloAction.cu === "new" ? '---' : arregloAction.codigoArreglo,
      anteojoCristalesDescripcion: arregloAnteojoCristales.arregloAnteojoCristalesDescripcion,
      armazonNuevoIdArmazon: arregloArmazonNuevo.arregloArmazonNuevoIdArmazon,
      armazonNuevoCodigoArmazon: arregloArmazonNuevo.arregloArmazonNuevoCodigoArmazon,
      armazonNuevoDescripcionArmazon: arregloArmazonNuevo.arregloArmazonNuevoDescripcionArmazon,
      armazonNuevoMarcaArmazon: arregloArmazonNuevo.arregloArmazonNuevoMarcaArmazon,
      armazonNuevoModeloArmazon: arregloArmazonNuevo.arregloArmazonNuevoModeloArmazon,
      armazonNuevoCategoriaArmazon: arregloArmazonNuevo.arregloArmazonNuevoCategoriaArmazon,
      armazonNuevoMaterialArmazon: arregloArmazonNuevo.arregloArmazonNuevoMaterialArmazon,
      armazonNuevoFormatoArmazon: arregloArmazonNuevo.arregloArmazonNuevoFormatoArmazon,
      armazonNuevoCalibreArmazon: arregloArmazonNuevo.arregloArmazonNuevoCalibreArmazon,
      armazonNuevoTipoArmazon: arregloArmazonNuevo.arregloArmazonNuevoTipoArmazon,
      armazonNuevoColorLenteArmazon: arregloArmazonNuevo.arregloArmazonNuevoColorLenteArmazon,
      armazonNuevoPrecioVentaArmazon: arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaArmazon,
      armazonNuevoPrecioVentaOriginalArmazon:
        arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaOriginalArmazon,
      armazonNuevoPorcentajeDescuentoArmazon:
        arregloArmazonNuevo.arregloArmazonNuevoPorcentajeDescuentoArmazon,
      armazonNuevoPrecioVentaContadoArmazon:
        arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaContadoArmazon,
      armazonClienteDescripcion: arregloArmazonCliente.arregloArmazonClienteDescripcion,
      arregloTableDescripcion:
        arregloArmazonNuevo.arregloArmazonNuevoCodigoArmazon !== ""
          ? arregloArmazonNuevo.arregloArmazonNuevoCodigoArmazon +
          " - " +
          arregloArmazonNuevo.arregloArmazonNuevoMarcaArmazon +
          " - " +
          arregloArmazonNuevo.arregloArmazonNuevoModeloArmazon
          : "ANTEOJO DE CLIENTE",
      servicios: _servicios,
      tratamientos: _tratamientos,
      fornituras: _fornituras,
      observaciones: arregloObservaciones.observaciones,
      totalArreglo: totalArreglo,
      totalArregloContado: totalArregloContado,
    };

    if (arregloAction.cu === "new") {
      setArreglos([...arreglos, _arreglo]);
      setArreglosSelected([...arreglosSelected, _arreglo.id]);
    } else {
      setArreglos(arreglos.map((item) => (item.id === arregloAction.idArreglo ? _arreglo : item)));
    }
    limpiaArreglo();
  };
  //
  // ################################################################################
  //
  const obtenerArreglo = (parRow, parAction) => {
    setArregloAction({
      cu: parAction,
      idArreglo: parRow.id,
      selectedArreglo: parRow.selectedArreglo,
      codigoArreglo: parRow.codigoArreglo,
    });

    const _arreglo = arreglos.find((arreglo) => arreglo.id === parRow.id);

    let _arregloAnteojoCristales = {
      arregloAnteojoCristalesDescripcion: _arreglo.anteojoCristalesDescripcion,
    };
    setArregloAnteojoCristales(_arregloAnteojoCristales);

    setArregloTabNuevoDeCliente(_arreglo.armazonNuevoIdArmazon !== "" ? 0 : 1);

    let _arregloArmazonNuevo = {
      arregloArmazonNuevoIdArmazon: _arreglo.armazonNuevoIdArmazon,
      arregloArmazonNuevoCodigoArmazon: _arreglo.armazonNuevoCodigoArmazon,
      arregloArmazonNuevoDescripcionArmazon: _arreglo.armazonNuevoDescripcionArmazon,
      arregloArmazonNuevoMarcaArmazon: _arreglo.armazonNuevoMarcaArmazon,
      arregloArmazonNuevoModeloArmazon: _arreglo.armazonNuevoModeloArmazon,
      arregloArmazonNuevoCategoriaArmazon: _arreglo.armazonNuevoCategoriaArmazon,
      arregloArmazonNuevoMaterialArmazon: _arreglo.armazonNuevoMaterialArmazon,
      arregloArmazonNuevoFormatoArmazon: _arreglo.armazonNuevoFormatoArmazon,
      arregloArmazonNuevoCalibreArmazon: _arreglo.armazonNuevoCalibreArmazon,
      arregloArmazonNuevoTipoArmazon: _arreglo.armazonNuevoTipoArmazon,
      arregloArmazonNuevoColorLenteArmazon: _arreglo.armazonNuevoColorLenteArmazon,
      arregloArmazonNuevoPrecioVentaArmazon: _arreglo.armazonNuevoPrecioVentaArmazon,
      arregloArmazonNuevoPrecioVentaOriginalArmazon:
        _arreglo.armazonNuevoPrecioVentaOriginalArmazon,
      arregloArmazonNuevoPorcentajeDescuentoArmazon:
        _arreglo.armazonNuevoPorcentajeDescuentoArmazon,
      arregloArmazonNuevoPrecioVentaContadoArmazon: _arreglo.armazonNuevoPrecioVentaContadoArmazon,
    };
    setArregloArmazonNuevo(_arregloArmazonNuevo);

    let _arregloArmazonCliente = {
      arregloArmazonClienteDescripcion: _arreglo.armazonClienteDescripcion,
    };
    setArregloArmazonCliente(_arregloArmazonCliente);

    let _arregloServiciosRows = [];
    if (_arreglo.servicios.length > 0) {
      _arregloServiciosRows = _arreglo.servicios.map((item) => {
        return {
          id: item.id,
          arregloServicioId: item.arregloServicioId,
          arregloServicioCodigo: item.arregloServicioCodigo,
          arregloServicioDescripcion: item.arregloServicioDescripcion,
          arregloServicioPrecioVenta: item.arregloServicioPrecioVenta,
          arregloServicioPrecioVentaOriginal: item.arregloServicioPrecioVentaOriginal,
          arregloServicioPorcentajeDescuento: item.arregloServicioPorcentajeDescuento,
          arregloServicioPrecioVentaContado: item.arregloServicioPrecioVentaContado,
          arregloServicioCantidad: item.arregloServicioCantidad,
          arregloServicioSubtotal: item.arregloServicioSubtotal,
          arregloServicioSubtotalContado: item.arregloServicioSubtotalContado,
        };
      });
    }
    setArregloServiciosRows(_arregloServiciosRows);

    let _arregloTratamientosRows = [];
    if (_arreglo.tratamientos.length > 0) {
      _arregloTratamientosRows = _arreglo.tratamientos.map((item) => {
        return {
          id: item.id,
          arregloTratamientoId: item.arregloTratamientoId,
          arregloTratamientoOjo: item.arregloTratamientoOjo,
          arregloTratamientoCodigo: item.arregloTratamientoCodigo,
          arregloTratamientoDescripcion: item.arregloTratamientoDescripcion,
          arregloTratamientoPrecioVenta: item.arregloTratamientoPrecioVenta,
          arregloTratamientoPrecioVentaOriginal: item.arregloTratamientoPrecioVentaOriginal,
          arregloTratamientoPorcentajeDescuento: item.arregloTratamientoPorcentajeDescuento,
          arregloTratamientoPrecioVentaContado: item.arregloTratamientoPrecioVentaContado,
        };
      });
    }
    setArregloTratamientosRows(_arregloTratamientosRows);

    let _arregloForniturasRows = [];
    if (_arreglo.fornituras.length > 0) {
      _arregloForniturasRows = _arreglo.fornituras.map((item) => {
        return {
          id: item.id,
          arregloFornituraId: item.arregloFornituraId,
          arregloFornituraCodigo: item.arregloFornituraCodigo,
          arregloFornituraDescripcion: item.arregloFornituraDescripcion,
          arregloFornituraPrecioVenta: item.arregloFornituraPrecioVenta,
          arregloFornituraPrecioVentaOriginal: item.arregloFornituraPrecioVentaOriginal,
          arregloFornituraPorcentajeDescuento: item.arregloFornituraPorcentajeDescuento,
          arregloFornituraPrecioVentaContado: item.arregloFornituraPrecioVentaContado,
          arregloFornituraCantidad: item.arregloFornituraCantidad,
          arregloFornituraSubtotal: item.arregloFornituraSubtotal,
          arregloFornituraSubtotalContado: item.arregloFornituraSubtotalContado,
        };
      });
    }
    setArregloForniturasRows(_arregloForniturasRows);

    let _arregloObservaciones = {
      observaciones: _arreglo.observaciones,
    };
    setArregloObservaciones(_arregloObservaciones);

    // expando los accordions que corresponda

    // setDisabledAccordionArreglo(false);
    setExpandedAccordionArreglo(true);
    setExpandedAccordionArregloAnteojoCristales(true);
    if (
      _arregloArmazonNuevo.arregloArmazonNuevoCodigoArmazon !== "" ||
      _arregloArmazonCliente.arregloArmazonClienteDescripcion !== ""
    ) {
      setExpandedAccordionArregloPaseCristales(true);
    }
    if (_arreglo.servicios.length > 0) {
      setExpandedAccordionArregloServicios(true);
    }
    if (_arreglo.tratamientos.length > 0) {
      setExpandedAccordionArregloTratamientos(true);
    }
    if (_arreglo.fornituras.length > 0) {
      setExpandedAccordionArregloFornituras(true);
    }
    if (_arreglo.observaciones) {
      setExpandedAccordionArregloObservaciones(true);
    }
  };
  //
  // ################################################################################
  //
  const quitarArreglo = (parRow) => {
    let _arreglos = arreglos.filter((arreglo) => arreglo.id !== parRow.id);
    let _arreglosSelected = [];

    _arreglos.forEach((item) => {
      if (item.selectedArreglo) {
        _arreglosSelected.push(item.id);
      }
    });

    setArreglos(_arreglos);
    setArreglosSelected(_arreglosSelected);
  };
  //
  // ################################################################################
  //
  const seleccionarArreglos = (parArreglosSelected) => {
    let _arreglos = [];
    if (parArreglosSelected.length === 0) {
      // si no hay arreglos seleccionados
      arreglos.forEach((item) => {
        item.selectedArreglo = false;
        _arreglos.push(item);
      });
    } else {
      // si hay arreglos seleccionados
      arreglos.forEach((item) => {
        if (parArreglosSelected.includes(item.id)) {
          // si el arreglo actual esta seleccionado
          item.selectedArreglo = true;
        } else {
          // si el arreglo actual esta seleccionado
          item.selectedArreglo = false;
        }
        _arreglos.push(item);
      });
    }
    setArreglos(_arreglos);
    setArreglosSelected(parArreglosSelected);
  };
  //
  // ################################################################################
  // calculo totales cuando en el arreglo el usuario agrega o quita un servicio, tratamiento, fornitura
  useEffect(() => {
    let _totalServicios = 0;
    arregloServiciosRows.forEach((item) => {
      _totalServicios += item.arregloServicioSubtotal;
    });
    setTotalArregloServicios(_totalServicios);

    let _totalServiciosContado = 0;
    arregloServiciosRows.forEach((item) => {
      _totalServiciosContado += item.arregloServicioSubtotalContado;
    });
    setTotalArregloServiciosContado(_totalServiciosContado);

    let _totalTratamientos = 0;
    arregloTratamientosRows.forEach((item) => {
      _totalTratamientos += item.arregloTratamientoPrecioVenta;
    });
    setTotalArregloTratamientos(_totalTratamientos);

    let _totalTratamientosContado = 0;
    arregloTratamientosRows.forEach((item) => {
      _totalTratamientosContado += item.arregloTratamientoPrecioVentaContado;
    });
    setTotalArregloTratamientosContado(_totalTratamientosContado);

    let _totalFornituras = 0;
    arregloForniturasRows.forEach((item) => {
      _totalFornituras += item.arregloFornituraSubtotal;
    });
    setTotalArregloFornituras(_totalFornituras);

    let _totalForniturasContado = 0;
    arregloForniturasRows.forEach((item) => {
      _totalForniturasContado += item.arregloFornituraSubtotalContado;
    });
    setTotalArregloForniturasContado(_totalForniturasContado);

    setTotalArreglo(
      arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaArmazon +
      totalArregloServicios +
      totalArregloFornituras +
      totalArregloTratamientos
    );

    setTotalArregloContado(
      arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaContadoArmazon +
      totalArregloServiciosContado +
      totalArregloForniturasContado +
      totalArregloTratamientosContado
    );
  }, [
    arregloServiciosRows,
    totalArregloServicios,
    totalArregloServiciosContado,
    arregloTratamientosRows,
    totalArregloTratamientos,
    totalArregloTratamientosContado,
    arregloForniturasRows,
    totalArregloFornituras,
    totalArregloForniturasContado,
    arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaArmazon,
    arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaContadoArmazon,
  ]);
  //
  // ################################################################################
  //
  const handleChangeArregloAnteojoCristales = (e) => {
    setArregloAnteojoCristales({
      ...arregloAnteojoCristales,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloArmazonNuevo = (e) => {
    setArregloArmazonNuevo({
      ...arregloArmazonNuevo,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloArmazonCliente = (e) => {
    setArregloArmazonCliente({
      ...arregloArmazonCliente,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloServicio = (e) => {
    setArregloServicio({
      ...arregloServicio,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloTratamiento = (e) => {
    setArregloTratamiento({
      ...arregloTratamiento,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloFornitura = (e) => {
    setArregloFornitura({
      ...arregloFornitura,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeArregloObservaciones = (e) => {
    setArregloObservaciones({
      ...arregloObservaciones,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  // metodos de productos
  // ################################################################################
  //
  const handleChangeProducto = (e) => {
    setProducto({
      ...producto,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const seleccionarProductos = (parProductosSelected) => {
    let _productos = [];
    if (parProductosSelected.length === 0) {
      // si no hay productos seleccionados
      productosRows.forEach((item) => {
        item.productoSelected = false;
        _productos.push(item);
      });
    } else {
      // si hay productos seleccionados
      productosRows.forEach((item) => {
        if (parProductosSelected.includes(item.id)) {
          // si el producto actual esta seleccionado
          item.productoSelected = true;
        } else {
          // si el producto actual esta seleccionado
          item.productoSelected = false;
        }
        _productos.push(item);
      });
    }
    setProductosRows(_productos);
    setProductosSelected(parProductosSelected);
  };
  //
  // ################################################################################
  //
  const limpiaProductos = () => {
    setProducto(initialProducto);
    setProductosRows([]);
    setTotalProductos(0);
    setTotalProductosContado(0);
    setExpandedAccordionProducto(false);
    setDisabledAccordionProducto(false);
    setShowCheckBoxesProductosRows(true);
    setShowActionsProductosRows(true);
  };
  //
  // ################################################################################
  // metodos de lentes de contacto
  // ################################################################################
  //
  const limpiaLentesContacto = () => {
    limpiaLenteContacto();
    setLentesContactoRows([]);
    setTotalLentesContacto(0);
    setTotalLentesContactoContado(0);
    setDisabledAccordionLenteContacto(false);
    setShowCheckBoxesLentesContactoRows(true);
    setShowActionsLentesContactoRows(true);
  };
  //
  // ################################################################################
  //
  const limpiaLenteContacto = () => {
    setLenteContactoAction({
      cu: "new",
    });
    setLenteContacto(initialLenteContacto);
    setDisabledDatosLenteContacto(true);
    setExpandedAccordionLenteContacto(false);
  };
  //
  // ################################################################################
  //
  const guardarLenteContacto = (lenteContactoDescripciones) => {
    if (lenteContactoAction.cu === "new") {
      // si estoy agregando lentes de contacto

      if (lenteContacto.lenteContactoOjo === "ambos") {
        // si es el mismo lc para los dos ojos

        let _lenteContactoRowsTmp = [];

        let _lenteContactoOJoDerecho = {
          id: uuidv4(),
          lenteContactoSelected: true,
          lenteContactoCodigo: lenteContacto.lenteContactoCodigo,
          lenteContactoOjo: "derecho",
          lenteContactoEsfera: lenteContacto.lenteContactoEsfera,
          lenteContactoCilindro: lenteContacto.lenteContactoCilindro,
          lenteContactoEje: lenteContacto.lenteContactoEje,
          lenteContactoCurvaBase: lenteContacto.lenteContactoCurvaBase,
          lenteContactoCurvaBaseValor: lenteContacto.lenteContactoCurvaBaseValor,
          lenteContactoDiametro: lenteContacto.lenteContactoDiametro,
          lenteContactoDiametroValor: lenteContacto.lenteContactoDiametroValor,
          lenteContactoAdicion: lenteContacto.lenteContactoAdicion,
          lenteContactoProducto: lenteContacto.lenteContactoProducto,
          lenteContactoProductoDescripcion:
            lenteContactoDescripciones.lenteContactoProductoDescripcion,
          lenteContactoProductoMultifocal: lenteContacto.lenteContactoProductoMultifocal,
          lenteContactoPresentacion: lenteContacto.lenteContactoPresentacion,
          lenteContactoPresentacionDescripcion:
            lenteContactoDescripciones.lenteContactoPresentacionDescripcion,
          lenteContactoPrecioVenta: lenteContacto.lenteContactoPrecioVenta,
          lenteContactoPrecioVentaOriginal: lenteContacto.lenteContactoPrecioVentaOriginal,
          lenteContactoPorcentajeDescuento: lenteContacto.lenteContactoPorcentajeDescuento,
          lenteContactoPrecioVentaContado: lenteContacto.lenteContactoPrecioVentaContado,
          lenteContactoCantidad: lenteContacto.lenteContactoCantidad,
          lenteContactoSubtotal: lenteContacto.lenteContactoSubtotal,
          lenteContactoSubtotalContado: lenteContacto.lenteContactoSubtotalContado,
          lenteContactoObservaciones: lenteContacto.lenteContactoObservaciones,
          lenteContactoVentaPorUnidad: lenteContacto.lenteContactoVentaPorUnidad,
        };
        _lenteContactoRowsTmp.push(_lenteContactoOJoDerecho);

        let _lenteContactoOJoIzquierdo = {
          id: uuidv4(),
          lenteContactoSelected: true,
          lenteContactoCodigo: lenteContacto.lenteContactoCodigo,
          lenteContactoOjo: "izquierdo",
          lenteContactoEsfera: lenteContacto.lenteContactoEsfera,
          lenteContactoCilindro: lenteContacto.lenteContactoCilindro,
          lenteContactoEje: lenteContacto.lenteContactoEje,
          lenteContactoCurvaBase: lenteContacto.lenteContactoCurvaBase,
          lenteContactoCurvaBaseValor: lenteContacto.lenteContactoCurvaBaseValor,
          lenteContactoDiametro: lenteContacto.lenteContactoDiametro,
          lenteContactoDiametroValor: lenteContacto.lenteContactoDiametroValor,
          lenteContactoAdicion: lenteContacto.lenteContactoAdicion,
          lenteContactoProducto: lenteContacto.lenteContactoProducto,
          lenteContactoProductoDescripcion:
            lenteContactoDescripciones.lenteContactoProductoDescripcion,
          lenteContactoProductoMultifocal: lenteContacto.lenteContactoProductoMultifocal,
          lenteContactoPresentacion: lenteContacto.lenteContactoPresentacion,
          lenteContactoPresentacionDescripcion:
            lenteContactoDescripciones.lenteContactoPresentacionDescripcion,
          lenteContactoPrecioVenta: lenteContacto.lenteContactoPrecioVenta,
          lenteContactoPrecioVentaOriginal: lenteContacto.lenteContactoPrecioVentaOriginal,
          lenteContactoPorcentajeDescuento: lenteContacto.lenteContactoPorcentajeDescuento,
          lenteContactoPrecioVentaContado: lenteContacto.lenteContactoPrecioVentaContado,
          lenteContactoCantidad: lenteContacto.lenteContactoCantidad,
          lenteContactoSubtotal: lenteContacto.lenteContactoSubtotal,
          lenteContactoSubtotalContado: lenteContacto.lenteContactoSubtotalContado,
          lenteContactoObservaciones: lenteContacto.lenteContactoObservaciones,
          lenteContactoVentaPorUnidad: lenteContacto.lenteContactoVentaPorUnidad,
        };
        _lenteContactoRowsTmp.push(_lenteContactoOJoIzquierdo);

        setLentesContactoRows([...lentesContactoRows, ..._lenteContactoRowsTmp]);

        setLentesContactoSelected([...lentesContactoSelected, ...[_lenteContactoOJoDerecho.id, _lenteContactoOJoIzquierdo.id]]);
      } else {
        // si no es el mismo lc para los dos ojos

        let _lenteContacto = {
          id: uuidv4(),
          lenteContactoSelected: true,
          lenteContactoCodigo: lenteContacto.lenteContactoCodigo,
          lenteContactoOjo: lenteContacto.lenteContactoOjo,
          lenteContactoEsfera: lenteContacto.lenteContactoEsfera,
          lenteContactoCilindro: lenteContacto.lenteContactoCilindro,
          lenteContactoEje: lenteContacto.lenteContactoEje,
          lenteContactoCurvaBase: lenteContacto.lenteContactoCurvaBase,
          lenteContactoCurvaBaseValor: lenteContacto.lenteContactoCurvaBaseValor,
          lenteContactoDiametro: lenteContacto.lenteContactoDiametro,
          lenteContactoDiametroValor: lenteContacto.lenteContactoDiametroValor,
          lenteContactoAdicion: lenteContacto.lenteContactoAdicion,
          lenteContactoProducto: lenteContacto.lenteContactoProducto,
          lenteContactoProductoDescripcion:
            lenteContactoDescripciones.lenteContactoProductoDescripcion,
          lenteContactoProductoMultifocal: lenteContacto.lenteContactoProductoMultifocal,
          lenteContactoPresentacion: lenteContacto.lenteContactoPresentacion,
          lenteContactoPresentacionDescripcion:
            lenteContactoDescripciones.lenteContactoPresentacionDescripcion,
          lenteContactoPrecioVenta: lenteContacto.lenteContactoPrecioVenta,
          lenteContactoPrecioVentaOriginal: lenteContacto.lenteContactoPrecioVentaOriginal,
          lenteContactoPorcentajeDescuento: lenteContacto.lenteContactoPorcentajeDescuento,
          lenteContactoPrecioVentaContado: lenteContacto.lenteContactoPrecioVentaContado,
          lenteContactoCantidad: lenteContacto.lenteContactoCantidad,
          lenteContactoSubtotal: lenteContacto.lenteContactoSubtotal,
          lenteContactoSubtotalContado: lenteContacto.lenteContactoSubtotalContado,
          lenteContactoObservaciones: lenteContacto.lenteContactoObservaciones,
          lenteContactoVentaPorUnidad: lenteContacto.lenteContactoVentaPorUnidad,
        };
        setLentesContactoRows([...lentesContactoRows, _lenteContacto]);
        setLentesContactoSelected([...lentesContactoSelected, _lenteContacto.id]);
      }
    } else {
      // si estoy editando una lente de contacto

      setLentesContactoRows(
        lentesContactoRows.map((item) => (item.id === lenteContacto.id ? lenteContacto : item))
      );
    }
    limpiaLenteContacto();
  };
  //
  // ################################################################################
  //
  const obtenerLenteContacto = (parRow, parAction) => {
    setLenteContactoAction({
      cu: parAction,
    });
    setLenteContacto(parRow);
    setExpandedAccordionLenteContacto(true);
    setDisabledDatosLenteContacto(false);
  };
  //
  // ################################################################################
  //
  const quitarLenteContacto = (parRow) => {
    let _lentesContacto = lentesContactoRows.filter(
      (item) => item.id !== parRow.id
    );
    let _lentesContactoSelected = [];

    _lentesContacto.forEach((item) => {
      if (item.lenteContactoSelected) {
        _lentesContactoSelected.push(item.id);
      }
    });
    setLentesContactoRows(_lentesContacto);
    setLentesContactoSelected(_lentesContactoSelected);
  };
  //
  // ################################################################################
  //
  const seleccionarLentesContacto = (parLentesContactoSelected) => {
    let _lentesContacto = [];
    if (parLentesContactoSelected.length === 0) {
      // si no hay lentes de contacto seleccionados
      lentesContactoRows.forEach((item, index) => {
        item.lenteContactoSelected = false;
        _lentesContacto.push(item);
      });
    } else {
      // si hay lentes de contacto seleccionados
      lentesContactoRows.forEach((item, index) => {
        if (parLentesContactoSelected.includes(item.id)) {
          // si el anteojo actual esta seleccionado
          item.lenteContactoSelected = true;
        } else {
          // si el anteojo actual esta seleccionado
          item.lenteContactoSelected = false;
        }
        _lentesContacto.push(item);
      });
    }
    setLentesContactoRows(_lentesContacto);
    setLentesContactoSelected(parLentesContactoSelected);
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (lenteContactoAction.cu === "new") {
      setLenteContactoOjoOptions([
        {
          id: "ambos",
          descripcion: "Ambos",
        },
        {
          id: "derecho",
          descripcion: "Derecho",
        },
        {
          id: "izquierdo",
          descripcion: "Izquierdo",
        },
      ]);
    } else {
      setLenteContactoOjoOptions([
        {
          id: "derecho",
          descripcion: "Derecho",
        },
        {
          id: "izquierdo",
          descripcion: "Izquierdo",
        },
      ]);
    }
  }, [lenteContactoAction]);
  //
  // ################################################################################
  //
  const handleChangeLenteContacto = (e) => {
    setLenteContacto({
      ...lenteContacto,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFinalizar = (e) => {
    setFinalizar({
      ...finalizar,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEntrega = (fechaEntrega) => {
    setFinalizar({
      ...finalizar,
      fechaEntrega: fechaEntrega,
    });
  };
  //
  // ################################################################################
  //
  const handleBlurFinalizar = (e) => {
    if (
      finalizar.totalFinalGestionAtencion == 0 ||
      finalizar.totalFinalGestionAtencion > finalizar.subTotalGestionAtencion
    ) {
      // si el usuario indica un importe final 0 o mayor al subtotal de la ga, no permito confirmar la ga
      setDisabledGestionParticularObraSocial(false);
      setDisabledConfirmarGestionAtencion(true);
      setDisabledModificarGestionAtencion(false);
      // setGestionAtencionConfirmada(false);
    } else {
      // si el usuario indica un importe final menor o igual al subtotal de la ga
      setDisabledGestionParticularObraSocial(true);
      setDisabledConfirmarGestionAtencion(false);
      setDisabledModificarGestionAtencion(true);
    }
  };
  //
  // ################################################################################
  //
  const limpiaGA = () => {
    limpiaCliente();
    limpiaReceta();
    limpiaAnteojo();
    setAnteojos([]);
    limpiaArreglo();
    setArreglos([]);
    limpiaProductos();
    limpiaLentesContacto();
    setFinalizar(initialFinalizar);
  };
  //
  // ################################################################################
  //
  const prepararGestionAtencionObject = () => {
    //
    // ------------------------------------------------------------------------------
    // preparo datos de cliente

    let _actividades = [];
    cliente.actividad.forEach((item) => {
      let _actividad = {
        id_actividad: item,
      };
      _actividades.push(_actividad);
    });

    let _ocupaciones = [];
    cliente.ocupacion.forEach((item) => {
      let _ocupacion = {
        id_ocupacion: item,
      };
      _ocupaciones.push(_ocupacion);
    });

    let _cliente = {
      id_cliente: cliente.id,
      id_tipo_documento: cliente.tipoDocumento,
      num_doc: cliente.numeroDocumento,
      numero_cuit_cuil: cliente.numeroCuitCuil,
      nombre: cliente.nombre,
      apellido: cliente.apellido,
      id_genero: cliente.genero,
      fecha_nac: format(cliente.fechaNacimiento, "yyyy/MM/dd"),
      email: cliente.eMail,
      telefono_movil: cliente.telefonoMovil,
      telefono: cliente.telefonoFijo,
      domicilio: cliente.domicilio,
      localidad: cliente.localidad,
      id_departamento: cliente.departamento,
      id_provincia: cliente.provincia,
      id_pais: cliente.pais,
      codigo_postal: cliente.codigoPostal,
      actividad_list: _actividades,
      otra_actividad: cliente.otraActividad,
      ocupacion_list: _ocupaciones,
      otra_ocupacion: cliente.otraOcupacion,
    };

    // ------------------------------------------------------------------------------
    // preparo datos de receta

    let _receta = [];
    if (recetaLejos.lejosCheck || recetaCerca.cercaCheck || recetaIntermedia.intermediaCheck) {
      // si hay datos de receta

      _receta = [
        {
          lejos: recetaLejos.lejosCheck,
          lejos_od_esfera: parseFloat(+recetaLejos.lejosOdEsfera),
          lejos_od_cilindro: parseFloat(+recetaLejos.lejosOdCilindro),
          lejos_od_eje: parseInt(+recetaLejos.lejosOdEje),
          lejos_od_prisma_valor: parseInt(+recetaLejos.lejosOdPrisma),
          lejos_od_prisma_tipo: recetaLejos.lejosOdPrismaSelect,
          lejos_od_eje_prisma: parseInt(+recetaLejos.lejosOdEjePrisma),
          lejos_oi_esfera: parseFloat(+recetaLejos.lejosOiEsfera),
          lejos_oi_cilindro: parseFloat(+recetaLejos.lejosOiCilindro),
          lejos_oi_eje: parseInt(+recetaLejos.lejosOiEje),
          lejos_oi_prisma_valor: parseInt(+recetaLejos.lejosOiPrisma),
          lejos_oi_prisma_tipo: recetaLejos.lejosOiPrismaSelect,
          lejos_oi_eje_prisma: parseInt(+recetaLejos.lejosOiEjePrisma),
          cerca: recetaCerca.cercaCheck,
          cerca_od_esfera: parseFloat(+recetaCerca.cercaOdEsfera),
          cerca_od_cilindro: parseFloat(+recetaCerca.cercaOdCilindro),
          cerca_od_eje: parseInt(+recetaCerca.cercaOdEje),
          cerca_od_prisma_valor: parseInt(+recetaCerca.cercaOdPrisma),
          cerca_od_prisma_tipo: recetaCerca.cercaOdPrismaSelect,
          cerca_od_eje_prisma: parseInt(+recetaCerca.cercaOdEjePrisma),
          cerca_oi_esfera: parseFloat(+recetaCerca.cercaOiEsfera),
          cerca_oi_cilindro: parseFloat(+recetaCerca.cercaOiCilindro),
          cerca_oi_eje: parseInt(+recetaCerca.cercaOiEje),
          cerca_oi_prisma_valor: parseInt(+recetaCerca.cercaOiPrisma),
          cerca_oi_prisma_tipo: recetaCerca.cercaOiPrismaSelect,
          cerca_oi_eje_prisma: parseInt(+recetaCerca.cercaOiEjePrisma),
          intermedia: recetaIntermedia.intermediaCheck,
          intermedia_od_esfera: parseFloat(+recetaIntermedia.intermediaOdEsfera),
          intermedia_od_cilindro: parseFloat(+recetaIntermedia.intermediaOdCilindro),
          intermedia_od_eje: parseInt(+recetaIntermedia.intermediaOdEje),
          intermedia_od_prisma_valor: parseInt(+recetaIntermedia.intermediaOdPrisma),
          intermedia_od_prisma_tipo: recetaIntermedia.intermediaOdPrismaSelect,
          intermedia_od_eje_prisma: parseInt(+recetaIntermedia.intermediaOdEjePrisma),
          intermedia_oi_esfera: parseFloat(+recetaIntermedia.intermediaOiEsfera),
          intermedia_oi_cilindro: parseFloat(+recetaIntermedia.intermediaOiCilindro),
          intermedia_oi_eje: parseInt(+recetaIntermedia.intermediaOiEje),
          intermedia_oi_prisma_valor: parseInt(+recetaIntermedia.intermediaOiPrisma),
          intermedia_oi_prisma_tipo: recetaIntermedia.intermediaOiPrismaSelect,
          intermedia_oi_eje_prisma: parseInt(+recetaIntermedia.intermediaOiEjePrisma),
          id_medico: recetaOtrosDatos.medico,
          id_instituto: recetaOtrosDatos.instituto,
          fecha_receta: recetaOtrosDatos.fechaReceta ? format(recetaOtrosDatos.fechaReceta, "yyyy/MM/dd") : null,
        },
      ];
    }

    // ------------------------------------------------------------------------------
    // preparo datos de anteojos

    let _anteojos = [];
    anteojos.forEach((item) => {
      if (item.selectedAnteojo) {
        // Si este anteojo esta seleccionado

        let _tratamientos = [];
        item.tratamientos.forEach((item) => {
          let _tratamiento = {
            id_articulo: item.anteojoTratamientoId,
            ojo: item.anteojoTratamientoOjo,
            precio_venta: item.anteojoTratamientoPrecioVenta,
            precio_venta_original: item.anteojoTratamientoPrecioVentaOriginal,
            porcentaje_descuento: item.anteojoTratamientoPorcentajeDescuento,
            precio_venta_contado: item.anteojoTratamientoPrecioVentaContado,
          };
          _tratamientos.push(_tratamiento);
        });

        let _anteojo = {
          tipo_anteojo: item.cristalesTipoAnteojo,
          cristal_ojo_derecho: item.cristalIdCristalProductoOD !== "" ? true : false,
          id_cristal_producto_od: item.cristalIdCristalProductoOD,
          id_bl_cr_diametro_od: item.cristalIdBlCrDiametroOD,
          id_bl_cr_adicion_od: item.cristalIdBlCrAdicionOD,
          precio_venta_cristal_od: item.cristalPrecioVentaOD,
          precio_venta_original_cristal_od: item.cristalPrecioVentaOriginalOD,
          porcentaje_descuento_cristal_od: item.cristalPorcentajeDescuentoOD,
          precio_venta_contado_cristal_od: item.cristalPrecioVentaContadoOD,
          cristal_ojo_izquierdo: item.cristalIdCristalProductoOI !== "" ? true : false,
          id_cristal_producto_oi: item.cristalIdCristalProductoOI,
          id_bl_cr_diametro_oi: item.cristalIdBlCrDiametroOI,
          id_bl_cr_adicion_oi: item.cristalIdBlCrAdicionOI,
          precio_venta_cristal_oi: item.cristalPrecioVentaOI,
          precio_venta_original_cristal_oi: item.cristalPrecioVentaOriginalOI,
          porcentaje_descuento_cristal_oi: item.cristalPorcentajeDescuentoOI,
          precio_venta_contado_cristal_oi: item.cristalPrecioVentaContadoOI,
          distancia_pupilar_od: item.cristalDistanciaPupilarOD,
          altura_pupilar_od: item.cristalAlturaPupilarOD,
          altura_parpado_inferior_od: item.cristalAlturaParpadoInferiorOD,
          distancia_pupilar_oi: item.cristalDistanciaPupilarOI,
          altura_pupilar_oi: item.cristalAlturaPupilarOI,
          altura_parpado_inferior_oi: item.cristalAlturaParpadoInferiorOI,
          montura_nuevo_cliente: item.armazonNuevoIdArmazon !== "" ? "nuevo" : "cliente",
          id_articulo_arm_asol: item.armazonNuevoIdArmazon,
          precio_venta_arm_asol: item.armazonNuevoPrecioVentaArmazon,
          precio_venta_original_arm_asol: item.armazonNuevoPrecioVentaOriginalArmazon,
          porcentaje_descuento_arm_asol: item.armazonNuevoPorcentajeDescuentoArmazon,
          precio_venta_contado_arm_asol: item.armazonNuevoPrecioVentaContadoArmazon,
          cliente_deja_su_anteojo: item.armazonClienteDejaSuAnteojo,
          estado_montura: item.armazonClienteDescripcion,
          medida_horizontal: item.armazonClienteDistanciaHorizontal,
          medida_vertical: item.armazonClienteDistanciaVertical,
          medida_diagonal: item.armazonClienteDistanciaDiagonal,
          medida_puente: item.armazonClienteDistanciaPuente,
          medida_mayor: item.armazonClienteDistanciaMayor,
          perfil: item.armazonClientePerfil,
          caracteristica: item.armazonClienteCaracteristica,
          base: parseInt(+item.armazonClienteBase),
          observaciones: item.observaciones,
          tratamiento_list: _tratamientos,
        };

        _anteojos.push(_anteojo);
      }
    });

    // ------------------------------------------------------------------------------
    // preparo datos de arreglos

    let _arreglos = [];
    arreglos.forEach((item) => {
      if (item.selectedArreglo) {
        // Si este arreglo esta seleccionado

        let _servicios = [];
        item.servicios.forEach((item) => {
          let _servicio = {
            id_articulo: item.arregloServicioId,
            precio_venta: item.arregloServicioPrecioVenta,
            precio_venta_original: item.arregloServicioPrecioVentaOriginal,
            cantidad: item.arregloServicioCantidad,
            porcentaje_descuento: item.arregloServicioPorcentajeDescuento,
            precio_venta_contado: item.arregloServicioPrecioVentaContado,
          };
          _servicios.push(_servicio);
        });

        let _tratamientos = [];
        item.tratamientos.forEach((item) => {
          let _tratamiento = {
            id_articulo: item.arregloTratamientoId,
            ojo: item.arregloTratamientoOjo,
            precio_venta: item.arregloTratamientoPrecioVenta,
            precio_venta_original: item.arregloTratamientoPrecioVentaOriginal,
            porcentaje_descuento: item.arregloTratamientoPorcentajeDescuento,
            precio_venta_contado: item.arregloTratamientoPrecioVentaContado,
          };
          _tratamientos.push(_tratamiento);
        });

        let _fornituras = [];
        item.fornituras.forEach((item) => {
          let _fornitura = {
            id_articulo: item.arregloFornituraId,
            precio_venta: item.arregloFornituraPrecioVenta,
            precio_venta_original: item.arregloFornituraPrecioVentaOriginal,
            cantidad: item.arregloFornituraCantidad,
            porcentaje_descuento: item.arregloFornituraPorcentajeDescuento,
            precio_venta_contado: item.arregloFornituraPrecioVentaContado,
          };
          _fornituras.push(_fornitura);
        });

        let _arreglo = {
          descripcion_anteojo_cristales: item.anteojoCristalesDescripcion,
          pase_de_cristales:
            item.armazonNuevoIdArmazon !== "" || item.armazonClienteDescripcion !== ""
              ? true
              : false,
          montura_nuevo_cliente: item.armazonNuevoIdArmazon !== "" ? "nuevo" : "cliente",
          id_articulo_arm_asol: item.armazonNuevoIdArmazon,
          precio_venta_arm_asol: item.armazonNuevoPrecioVentaArmazon,
          precio_venta_original_arm_asol: item.armazonNuevoPrecioVentaOriginalArmazon,
          porcentaje_descuento_arm_asol: item.armazonNuevoPorcentajeDescuentoArmazon,
          precio_venta_contado_arm_asol: item.armazonNuevoPrecioVentaContadoArmazon,
          estado_montura: item.armazonClienteDescripcion,
          observaciones: item.observaciones,
          servicio_list: _servicios,
          tratamiento_list: _tratamientos,
          fornitura_list: _fornituras,
        };

        _arreglos.push(_arreglo);
      }
    });

    // ------------------------------------------------------------------------------
    // preparo datos de productos

    let _productos = [];
    productosRows.forEach((item) => {
      if (item.productoSelected) {
        let _producto = {
          id_articulo: item.productoId,
          precio_venta: item.productoPrecioVenta,
          precio_venta_original: item.productoPrecioVentaOriginal,
          cantidad: item.productoCantidad,
          porcentaje_descuento: item.productoPorcentajeDescuento,
          precio_venta_contado: item.productoPrecioVentaContado,
        };
        _productos.push(_producto);
      }
    });

    // ------------------------------------------------------------------------------
    // preparo datos de lentes de contacto

    let _lentesContacto = [];
    lentesContactoRows.forEach((item) => {
      if (item.lenteContactoSelected) {
        let _lenteContacto = {
          ojo: item.lenteContactoOjo,
          esfera: parseFloat(+item.lenteContactoEsfera),
          cilindro: parseFloat(+item.lenteContactoCilindro),
          eje: item.lenteContactoEje,
          id_lc_curva: item.lenteContactoCurvaBase,
          id_lc_diametro: item.lenteContactoDiametro,
          id_lente_contacto_producto: item.lenteContactoProducto,
          multifocal: item.lenteContactoProductoMultifocal,
          adicion: item.lenteContactoAdicion,
          id_lc_presentacion: item.lenteContactoPresentacion,
          precio_venta: item.lenteContactoPrecioVenta,
          precio_venta_original: item.lenteContactoPrecioVentaOriginal,
          cantidad: item.lenteContactoCantidad,
          porcentaje_descuento: item.lenteContactoPorcentajeDescuento,
          precio_venta_contado: item.lenteContactoPrecioVentaContado,
          venta_por_unidad: item.lenteContactoVentaPorUnidad === "Unidad" ? true : false,
        };
        _lentesContacto.push(_lenteContacto);
      }
    });

    // ------------------------------------------------------------------------------
    // preparo datos de finalizacion de la ga

    let _final = {
      id_gc_estado: gaAction.idGestionAtencionEstado,
      particular_osocial: particularObraSocial,
      concretada_nconcretada: ventaConcretadaNoConcretada,
      concretada: {
        id_area_entrega: finalizar.areaEntrega ? finalizar.areaEntrega : "",
        fecha_entrega: finalizar.fechaEntrega ? format(finalizar.fechaEntrega, "yyyy/MM/dd") : null,
      },
      no_concretada: {
        id_motivo_venta_no_concretada: finalizar.motivoVentaNoConcretada ? finalizar.motivoVentaNoConcretada : "",
        detalle_venta_no_concretada: finalizar.detalleVentaNoConcretada,
        emite_noemite_presupuesto: emiteNoEmitePresupuesto,
        texto_presupuesto: finalizar.textoPresupuesto,
      },
    };

    let _gestionAtencion = {
      codigo: codigoGA,
      cliente: _cliente,
      receta: _receta,
      anteojo_list: _anteojos,
      arreglo_list: _arreglos,
      otro_producto_list: _productos,
      lente_contacto_list: _lentesContacto,
      final: _final,
    };

    if (gaAction.cu === "update") {
      _gestionAtencion.id = gaAction.idGestionAtencion;
    }

    return _gestionAtencion;
  };
  //
  // ################################################################################
  //
  const validarDatosCliente = () => {
    let _error = true;
    let _messageText = "";

    if (cliente.fechaNacimiento !== null) {
      if (typeof cliente.fechaNacimiento == "string") {
        cliente.fechaNacimiento = new Date(cliente.fechaNacimiento);
      }
    }

    if (cliente.tipoDocumento === "") {
      _error = false;
      _messageText = "Debes seleccionar el tipo de documento del Cliente";
    } else if (!isPositiveInteger(cliente.numeroDocumento) || cliente.numeroDocumento.length < 7) {
      _error = false;
      _messageText = "El documento del Cliente debe ser un número de 7 o más dígitos";
    } else if (
      cliente.numeroCuitCuil !== "" &&
      (!isPositiveInteger(cliente.numeroCuitCuil) || cliente.numeroCuitCuil.length < 11)
    ) {
      _error = false;
      _messageText = "El numero de CUIT/CUIL del Cliente debe ser un número de 11 dígitos";
    } else if (
      cliente.nombre === "" ||
      cliente.nombre.length < 3 ||
      !onlyLettersAndSpaces(cliente.nombre)
    ) {
      _error = false;
      _messageText = "El nombre del Cliente no es válido";
    } else if (
      cliente.apellido === "" ||
      cliente.apellido.length < 3 ||
      !onlyLettersAndSpaces(cliente.apellido)
    ) {
      _error = false;
      _messageText = "El apellido del Cliente no es válido";
    } else if (cliente.genero === "") {
      _error = false;
      _messageText = "Debes seleccionar el género del Cliente";
    } else if (
      cliente.fechaNacimiento === null ||
      !isValid(cliente.fechaNacimiento) ||
      isBefore(new Date(), cliente.fechaNacimiento) ||
      calculateDifferenceYears(format(cliente.fechaNacimiento, "yyyy-MM-dd HH:mm:ss")) > 120
    ) {
      // si la fecha es nula o no tiene formato valido o es posterior a hoy o si la edad a partir de la fecha de nacimiento es mayor a 120 años
      _error = false;
      _messageText = "La fecha de nacimiento del Cliente no es válida";
    } else if (cliente.eMail !== "" && !isValidEmail(cliente.eMail)) {
      _error = false;
      _messageText = "El mail del Cliente no es válido";
    }

    return {
      error: _error,
      messageText: _messageText,
    };
  };
  //
  // ################################################################################
  //
  const validarDatosReceta = () => {
    let _error = true;
    let _messageText = "";

    if (recetaOtrosDatos.fechaReceta !== null) {
      if (typeof recetaOtrosDatos.fechaReceta == "string") {
        recetaOtrosDatos.fechaReceta = new Date(recetaOtrosDatos.fechaReceta);
      }
    }

    if (recetaOtrosDatos.medico === "") {
      _error = false;
      _messageText = "Debes seleccionar el médico que realizó la receta";
    } else if (
      recetaOtrosDatos.fechaReceta === null ||
      !isValid(recetaOtrosDatos.fechaReceta) ||
      isBefore(new Date(), recetaOtrosDatos.fechaReceta) ||
      calculateDifferenceYears(format(recetaOtrosDatos.fechaReceta, "yyyy-MM-dd HH:mm:ss")) > 1
    ) {
      // si la fecha es nula o no tiene formato valido o es posterior a hoy o si se emitio hace mas de un anio
      _error = false;
      _messageText = "La fecha de la receta no es válida";
    }

    return {
      error: _error,
      messageText: _messageText,
    };
  };
  //
  // ################################################################################
  //
  const setGestionAtencion = (parGestionAtencion, parAction) => {

    setGaAction({
      cu: parAction,
      idGestionAtencion: parGestionAtencion.id,
      idGestionAtencionEstado: parGestionAtencion.final.id_gc_estado,
    });

    setCodigoGA(parGestionAtencion.codigo);
    setSucursalGA(parGestionAtencion.descripcion_area);
    setUsuarioGA(parGestionAtencion.nombre_usuario + " " + parGestionAtencion.apellido_usuario);
    setFechaCreacionGA(parGestionAtencion.fecha_creacion);

    // -------------------------------------------------------------------------------
    // de la ga obtengo el cliente y asigno los valores

    let _clienteObject = parGestionAtencion.cliente;
    let _fechaNacimiento = _clienteObject.fecha_nac ? parse(_clienteObject.fecha_nac, "dd/MM/yyyy", new Date()) : null;
    let _cliente = {
      id: _clienteObject.id_cliente,
      tipoDocumento: _clienteObject.id_tipo_documento,
      numeroDocumento: _clienteObject.num_doc,
      numeroCuitCuil: _clienteObject.numero_cuit_cuil,
      nombre: _clienteObject.nombre,
      apellido: _clienteObject.apellido,
      genero: _clienteObject.id_genero,
      fechaNacimiento: _fechaNacimiento,
      edadActual: calculateDifferenceYears(_fechaNacimiento),
      eMail: _clienteObject.email,
      telefonoMovil: _clienteObject.telefono_movil,
      telefonoFijo: _clienteObject.telefono,
      domicilio: _clienteObject.domicilio,
      localidad: _clienteObject.localidad,
      departamento: _clienteObject.id_departamento ?? "",
      provincia: _clienteObject.id_provincia ?? "",
      pais: _clienteObject.id_pais ?? "",
      codigoPostal: _clienteObject.codigo_postal,
      actividad: _clienteObject.actividad_list,
      otraActividad: _clienteObject.otra_actividad,
      ocupacion: _clienteObject.ocupacion_list,
      otraOcupacion: _clienteObject.otra_ocupacion,
    };

    setCliente(_cliente);
    setIsSetClient(true);
    setIsNewClient(false);
    setDisabledCliente(true);

    // -------------------------------------------------------------------------------
    // de la ga obtengo la receta y asigno los valores

    let _recetaObject = parGestionAtencion.receta;
    if (!isEmptyObject(_recetaObject)) {
      // si la ga tiene receta

      let _recetaLejos = {
        lejosCheck: _recetaObject.lejos,
        lejosOdEsfera: _recetaObject.lejos_od_esfera ?? 0,
        lejosOdCilindro: _recetaObject.lejos_od_cilindro ?? 0,
        lejosOdEje: _recetaObject.lejos_od_eje ?? 0,
        lejosOdPrisma: _recetaObject.lejos_od_prisma_valor ?? 0,
        lejosOdPrismaSelect: _recetaObject.lejos_od_prisma_tipo ?? "",
        lejosOdEjePrisma: _recetaObject.lejos_od_eje_prisma ?? 0,
        lejosOiEsfera: _recetaObject.lejos_oi_esfera ?? 0,
        lejosOiCilindro: _recetaObject.lejos_oi_cilindro ?? 0,
        lejosOiEje: _recetaObject.lejos_oi_eje ?? 0,
        lejosOiPrisma: _recetaObject.lejos_oi_prisma_valor ?? 0,
        lejosOiPrismaSelect: _recetaObject.lejos_oi_prisma_tipo ?? "",
        lejosOiEjePrisma: _recetaObject.lejos_oi_eje_prisma ?? 0,
      };
      let _recetaCerca = {
        cercaCheck: _recetaObject.cerca,
        cercaOdEsfera: _recetaObject.cerca_od_esfera ?? 0,
        cercaOdCilindro: _recetaObject.cerca_od_cilindro ?? 0,
        cercaOdEje: _recetaObject.cerca_od_eje ?? 0,
        cercaOdPrisma: _recetaObject.cerca_od_prisma_valor ?? 0,
        cercaOdPrismaSelect: _recetaObject.cerca_od_prisma_tipo ?? "",
        cercaOdEjePrisma: _recetaObject.cerca_od_eje_prisma ?? 0,
        cercaOiEsfera: _recetaObject.cerca_oi_esfera ?? 0,
        cercaOiCilindro: _recetaObject.cerca_oi_cilindro ?? 0,
        cercaOiEje: _recetaObject.cerca_oi_eje ?? 0,
        cercaOiPrisma: _recetaObject.cerca_oi_prisma_valor ?? 0,
        cercaOiPrismaSelect: _recetaObject.cerca_oi_prisma_tipo ?? "",
        cercaOiEjePrisma: _recetaObject.cerca_oi_eje_prisma ?? 0,
      };
      let _recetaIntermedia = {
        intermediaCheck: _recetaObject.intermedia,
        intermediaOdEsfera: _recetaObject.intermedia_od_esfera ?? 0,
        intermediaOdCilindro: _recetaObject.intermedia_od_cilindro ?? 0,
        intermediaOdEje: _recetaObject.intermedia_od_eje ?? 0,
        intermediaOdPrisma: _recetaObject.intermedia_od_prisma_valor ?? 0,
        intermediaOdPrismaSelect: _recetaObject.intermedia_od_prisma_tipo ?? "",
        intermediaOdEjePrisma: _recetaObject.intermedia_od_eje_prisma ?? 0,
        intermediaOiEsfera: _recetaObject.intermedia_oi_esfera ?? 0,
        intermediaOiCilindro: _recetaObject.intermedia_oi_cilindro ?? 0,
        intermediaOiEje: _recetaObject.intermedia_oi_eje ?? 0,
        intermediaOiPrisma: _recetaObject.intermedia_oi_prisma_valor ?? 0,
        intermediaOiPrismaSelect: _recetaObject.intermedia_oi_prisma_tipo ?? "",
        intermediaOiEjePrisma: _recetaObject.intermedia_oi_eje_prisma ?? 0,
      };
      let _recetaOtrosDatos = {
        medico: _recetaObject.id_medico ?? "",
        instituto: _recetaObject.id_instituto ?? "",
        fechaReceta: _recetaObject.fecha_receta ? parse(_recetaObject.fecha_receta, "dd/MM/yyyy", new Date()) : null,
      };

      setIsRecetaError(false);
      setRecetaLejos(_recetaLejos);
      setRecetaLejosDisabled(false);
      setRecetaCerca(_recetaCerca);
      setRecetaCercaDisabled(false);
      setRecetaIntermedia(_recetaIntermedia);
      setRecetaIntermediaDisabled(false);
      setRecetaOtrosDatos(_recetaOtrosDatos);
    }
    setDisabledReceta(true);

    // -------------------------------------------------------------------------------
    // de la ga obtengo los anteojos y asigno los valores

    let _anteojosObject = parGestionAtencion.anteojo_list;
    let _anteojos = [];
    let _anteojosSelected = [];

    if (_anteojosObject.length > 0) {
      // si la ga tiene anteojos

      _anteojosObject.forEach((item) => {
        // para cada anteojo de la ga

        // obtengo los tratamientos del anteojo
        let _tratamientos = [];
        if (item.tratamiento_list.length > 0) {
          // si este anteojo de la ga tiene tratamientos

          item.tratamiento_list.forEach((item) => {
            // para cada tratamiento del anteojo

            _tratamientos.push({
              id: item.id,
              anteojoTratamientoId: item.id_articulo,
              anteojoTratamientoOjo: item.ojo,
              anteojoTratamientoCodigo: item.codigo_articulo,
              anteojoTratamientoDescripcion: item.descripcion_articulo,
              anteojoTratamientoPrecioVenta: item.precio_venta,
              anteojoTratamientoPrecioVentaOriginal: item.precio_venta_original,
              anteojoTratamientoPorcentajeDescuento: item.porcentaje_descuento,
              anteojoTratamientoPrecioVentaContado: item.precio_venta_contado,
            });
          });
        }

        let _anteojo = {
          id: item.id,
          codigoAnteojo: item.codigo,
          selectedAnteojo: true,
          armazonNuevoIdArmazon: item.id_articulo_arm_asol ?? "",
          armazonNuevoCodigoArmazon: item.codigo_articulo_arm_asol ?? "",
          armazonNuevoDescripcionArmazon: item.descripcion_articulo_arm_asol ?? "",
          armazonNuevoMarcaArmazon: item.descripcion_ar_as_marca ?? "",
          armazonNuevoModeloArmazon: item.modelo_articulo_arm_asol ?? "",
          armazonNuevoCategoriaArmazon: item.descripcion_ar_as_categoria ?? "",
          armazonNuevoMaterialArmazon: item.descripcion_ar_as_material ?? "",
          armazonNuevoFormatoArmazon: item.descripcion_ar_as_formato ?? "",
          armazonNuevoCalibreArmazon: item.valor_ar_as_calibre ?? "",
          armazonNuevoTipoArmazon: item.descripcion_ar_as_tipo ?? "",
          armazonNuevoColorLenteArmazon: item.descripcion_as_color_lente ?? "",
          armazonNuevoPrecioVentaArmazon: item.precio_venta_arm_asol ?? 0,
          armazonNuevoPrecioVentaOriginalArmazon: item.precio_venta_original_arm_asol ?? 0,
          armazonNuevoPorcentajeDescuentoArmazon: item.porcentaje_descuento_arm_asol ?? 0,
          armazonNuevoPrecioVentaContadoArmazon: item.precio_venta_contado_arm_asol ?? 0,
          armazonClienteDescripcion: item.estado_montura ?? "",
          armazonClienteDistanciaHorizontal: item.medida_horizontal ?? 0,
          armazonClienteDistanciaVertical: item.medida_vertical ?? 0,
          armazonClienteDistanciaDiagonal: item.medida_diagonal ?? 0,
          armazonClienteDistanciaPuente: item.medida_puente ?? 0,
          armazonClienteDistanciaMayor: item.medida_mayor ?? 0,
          armazonClientePerfil: item.perfil ?? "",
          armazonClienteCaracteristica: item.caracteristica ?? "",
          armazonClienteBase: item.base ?? "",
          armazonClienteDejaSuAnteojo: item.cliente_deja_su_anteojo ?? true,
          anteojoTableDescripcion:
            (item.codigo_articulo_arm_asol ?? "") !== ""
              ? item.codigo_articulo_arm_asol +
              " - " +
              item.descripcion_ar_as_marca +
              " - " +
              item.modelo_articulo_arm_asol
              : "ANTEOJO DE CLIENTE",
          cristalesTipoAnteojoDisabled: true,
          cristalesTipoAnteojo: item.tipo_anteojo,
          cristalIdCristalProductoOD: item.id_cristal_producto_od ?? "",
          cristalIdBlCrDiametroOD: item.id_bl_cr_diametro_od ?? "",
          cristalIdBlCrAdicionOD: item.id_bl_cr_adicion_od ?? "",
          cristalDescripcionOD: item.descripcion_cristal_producto_od ?? "",
          cristalPrecioVentaOD: item.precio_venta_cristal_od ?? 0,
          cristalPrecioVentaOriginalOD: item.precio_venta_original_cristal_od ?? 0,
          cristalPorcentajeDescuentoOD: item.porcentaje_descuento_cristal_od ?? 0,
          cristalPrecioVentaContadoOD: item.precio_venta_contado_cristal_od ?? 0,
          cristalSolictaDatosMonturaClienteOD: item.solicita_datos_montura_cliente_od ?? "",
          cristalIdCristalProductoOI: item.id_cristal_producto_oi ?? "",
          cristalIdBlCrDiametroOI: item.id_bl_cr_diametro_oi ?? "",
          cristalIdBlCrAdicionOI: item.id_bl_cr_adicion_oi ?? "",
          cristalDescripcionOI: item.descripcion_cristal_producto_oi ?? "",
          cristalPrecioVentaOI: item.precio_venta_cristal_oi ?? 0,
          cristalPrecioVentaOriginalOI: item.precio_venta_original_cristal_oi ?? 0,
          cristalPorcentajeDescuentoOI: item.porcentaje_descuento_cristal_oi ?? 0,
          cristalPrecioVentaContadoOI: item.precio_venta_contado_cristal_oi ?? 0,
          cristalSolictaDatosMonturaClienteOI: item.solicita_datos_montura_cliente_oi ?? "",
          cristalDistanciaPupilarOD: item.distancia_pupilar_od ?? "",
          cristalDistanciaPupilarOI: item.distancia_pupilar_oi ?? "",
          cristalAlturaPupilarOD: item.altura_pupilar_od ?? "",
          cristalAlturaPupilarOI: item.altura_pupilar_oi ?? "",
          cristalAlturaParpadoInferiorOD: item.altura_parpado_inferior_od ?? "",
          cristalAlturaParpadoInferiorOI: item.altura_parpado_inferior_oi ?? "",
          tratamientos: _tratamientos,
          observaciones: item.observaciones ?? "",
          totalAnteojo: item.total_anteojo,
          totalAnteojoContado: item.total_anteojo_contado,
          actionEstadoAnteojo: parGestionAtencion.final.concretada_nconcretada,
        };
        _anteojos.push(_anteojo);
        _anteojosSelected.push(_anteojo.id);
      });
    }
    setAnteojos(_anteojos);
    setAnteojosSelected(_anteojosSelected);
    setDisabledAccordionAnteojo(true);
    setShowCheckBoxesAnteojosRows(false);
    setShowActionsAnteojosRows(false);

    // -------------------------------------------------------------------------------
    // de la ga obtengo los arreglos y asigno los valores

    let _arreglosObject = parGestionAtencion.arreglo_list;
    let _arreglos = [];
    let _arreglosSelected = [];

    if (_arreglosObject.length > 0) {
      // si la ga tiene arreglos

      _arreglosObject.forEach((item) => {
        // para cada arreglo de la ga

        // obtengo los servicios del arreglo
        let _servicios = [];
        if (item.servicio_list.length > 0) {
          // si este arreglo de la ga tiene servicios

          item.servicio_list.forEach((item) => {
            // para cada servicio del arreglo

            _servicios.push({
              id: item.id,
              arregloServicioId: item.id_articulo,
              arregloServicioCodigo: item.codigo_articulo,
              arregloServicioDescripcion: item.descripcion_articulo,
              arregloServicioPrecioVenta: item.precio_venta,
              arregloServicioPrecioVentaOriginal: item.precio_venta_original,
              arregloServicioPorcentajeDescuento: item.porcentaje_descuento,
              arregloServicioPrecioVentaContado: item.precio_venta_contado,
              arregloServicioCantidad: item.cantidad,
              arregloServicioSubtotal: item.precio_venta * item.cantidad,
              arregloServicioSubtotalContado: item.precio_venta_contado * item.cantidad,
            });
          });
        }

        // obtengo los tratamientos del arreglo
        let _tratamientos = [];
        if (item.tratamiento_list.length > 0) {
          // si este arreglo de la ga tiene tratamientos

          item.tratamiento_list.forEach((item) => {
            // para cada tratamiento del arreglo

            _tratamientos.push({
              id: item.id,
              arregloTratamientoId: item.id_articulo,
              arregloTratamientoOjo: item.ojo,
              arregloTratamientoCodigo: item.codigo_articulo,
              arregloTratamientoDescripcion: item.descripcion_articulo,
              arregloTratamientoPrecioVenta: item.precio_venta,
              arregloTratamientoPrecioVentaOriginal: item.precio_venta_original,
              arregloTratamientoPorcentajeDescuento: item.porcentaje_descuento,
              arregloTratamientoPrecioVentaContado: item.precio_venta_contado,
            });
          });
        }

        // obtengo las fornituras del arreglo
        let _fornituras = [];
        if (item.fornitura_list.length > 0) {
          // si este arreglo de la ga tiene fornituras

          item.fornitura_list.forEach((item) => {
            // para cada fornitura del arreglo

            _fornituras.push({
              id: item.id,
              arregloFornituraId: item.id_articulo,
              arregloFornituraCodigo: item.codigo_articulo,
              arregloFornituraDescripcion: item.descripcion_articulo,
              arregloFornituraPrecioVenta: item.precio_venta,
              arregloFornituraPrecioVentaOriginal: item.precio_venta_original,
              arregloFornituraPorcentajeDescuento: item.porcentaje_descuento,
              arregloFornituraPrecioVentaContado: item.precio_venta_contado,
              arregloFornituraCantidad: item.cantidad,
              arregloFornituraSubtotal: item.precio_venta * item.cantidad,
              arregloFornituraSubtotalContado: item.precio_venta_contado * item.cantidad,
            });
          });
        }

        let _arreglo = {
          id: item.id,
          codigoArreglo: item.codigo,
          selectedArreglo: true,
          anteojoCristalesDescripcion: item.descripcion_anteojo_cristales ?? "",
          armazonNuevoIdArmazon: item.id_articulo_arm_asol ?? "",
          armazonNuevoCodigoArmazon: item.codigo_articulo_arm_asol ?? "",
          armazonNuevoDescripcionArmazon: item.descripcion_articulo_arm_asol ?? "",
          armazonNuevoMarcaArmazon: item.descripcion_ar_as_marca ?? "",
          armazonNuevoModeloArmazon: item.modelo_articulo_arm_asol ?? "",
          armazonNuevoCategoriaArmazon: item.descripcion_ar_as_categoria ?? "",
          armazonNuevoMaterialArmazon: item.descripcion_ar_as_material ?? "",
          armazonNuevoFormatoArmazon: item.descripcion_ar_as_formato ?? "",
          armazonNuevoCalibreArmazon: item.valor_ar_as_calibre ?? "",
          armazonNuevoTipoArmazon: item.descripcion_ar_as_tipo ?? "",
          armazonNuevoColorLenteArmazon: item.descripcion_as_color_lente ?? "",
          armazonNuevoPrecioVentaArmazon: item.precio_venta_arm_asol ?? 0,
          armazonNuevoPrecioVentaOriginalArmazon: item.precio_venta_original_arm_asol ?? 0,
          armazonNuevoPorcentajeDescuentoArmazon: item.porcentaje_descuento_arm_asol ?? 0,
          armazonNuevoPrecioVentaContadoArmazon: item.precio_venta_contado_arm_asol ?? 0,
          armazonClienteDescripcion: item.estado_montura ?? "",
          arregloTableDescripcion:
            (item.codigo_articulo_arm_asol ?? "") !== ""
              ? item.codigo_articulo_arm_asol +
              " - " +
              item.descripcion_ar_as_marca +
              " - " +
              item.modelo_articulo_arm_asol
              : "ANTEOJO DE CLIENTE",
          servicios: _servicios,
          tratamientos: _tratamientos,
          fornituras: _fornituras,
          observaciones: item.observaciones ?? "",
          totalArreglo: item.total_arreglo,
          totalArregloContado: item.total_arreglo_contado,
          actionEstadoArreglo: parGestionAtencion.final.concretada_nconcretada,
        };
        _arreglos.push(_arreglo);
        _arreglosSelected.push(_arreglo.id);
      });
    }
    setArreglos(_arreglos);
    setArreglosSelected(_arreglosSelected);
    setDisabledAccordionArreglo(true);
    setShowCheckBoxesArreglosRows(false);
    setShowActionsArreglosRows(false);

    // -------------------------------------------------------------------------------
    // de la ga obtengo los otros productos y asigno los valores

    let _productosObject = parGestionAtencion.otro_producto_list;
    let _productos = [];
    let _productosSelected = [];

    if (_productosObject.length > 0) {
      // si la ga tiene otros productos

      _productosObject.forEach((item) => {
        // para cada otro producto de la ga

        let _producto = {
          id: item.id,
          productoSelected: true,
          productoId: item.id_articulo,
          productoCodigo: item.codigo_articulo,
          productoDescripcion: item.descripcion_articulo,
          productoPrecioVenta: item.precio_venta,
          productoPrecioVentaOriginal: item.precio_venta_original,
          productoPorcentajeDescuento: item.porcentaje_descuento,
          productoPrecioVentaContado: item.precio_venta_contado,
          productoCantidad: item.cantidad,
          productoSubtotal: item.precio_venta * item.cantidad,
          productoSubtotalContado: item.precio_venta_contado * item.cantidad,
        };
        _productos.push(_producto);
        _productosSelected.push(_producto.id);
      });
    }
    setProductosRows(_productos);
    setProductosSelected(_productosSelected);
    setDisabledAccordionProducto(true);
    setShowCheckBoxesProductosRows(false);
    setShowActionsProductosRows(false);

    // -------------------------------------------------------------------------------
    // de la ga obtengo los lentes de contacto y asigno los valores

    let _lentesContactoObject = parGestionAtencion.lente_contacto_list;
    let _lentesContacto = [];
    let _lentesContactoSelected = [];

    if (_lentesContactoObject.length > 0) {
      // si la ga tiene lentes de contacto

      _lentesContactoObject.forEach((item) => {
        // para cada lente de contacto de la ga

        let _lenteContacto = {
          id: item.id,
          lenteContactoSelected: true,
          // lenteContactoId: item.id,
          lenteContactoOjo: item.ojo,
          // lenteContactoCodigo: item.,
          lenteContactoEsfera: item.esfera,
          lenteContactoCilindro: item.cilindro,
          lenteContactoEje: item.eje,
          lenteContactoCurvaBase: item.id_lc_curva,
          lenteContactoCurvaBaseValor: item.valor_curva,
          lenteContactoDiametro: item.id_lc_diametro,
          lenteContactoDiametroValor: item.valor_diametro,
          lenteContactoAdicion: item.adicion,
          lenteContactoProducto: item.id_lente_contacto_producto,
          lenteContactoProductoDescripcion: item.descripcion_lente_contacto_producto,
          lenteContactoProductoMultifocal: item.multifocal_lente_contacto_producto,
          lenteContactoPresentacion: item.id_lc_presentacion,
          lenteContactoPresentacionDescripcion: item.descripcion_lc_presentacion,
          lenteContactoPrecioVenta: item.precio_venta,
          lenteContactoPrecioVentaOriginal: item.precio_venta_original,
          lenteContactoPorcentajeDescuento: item.porcentaje_descuento,
          lenteContactoPrecioVentaContado: item.precio_venta_contado,
          lenteContactoCantidad: item.cantidad,
          lenteContactoSubtotal: item.precio_venta * item.cantidad,
          lenteContactoSubtotalContado: item.precio_venta_contado * item.cantidad,
          lenteContactoObservaciones: item.observaciones,
          lenteContactoVentaPorUnidad: item.venta_por_unidad === true ? "Unidad" : "Caja",
        };
        _lentesContacto.push(_lenteContacto);
        _lentesContactoSelected.push(_lenteContacto.id);
      });
    }
    setLentesContactoRows(_lentesContacto);
    setLentesContactoSelected(_lentesContactoSelected);
    setDisabledAccordionLenteContacto(true);
    setShowCheckBoxesLentesContactoRows(false);
    setShowActionsLentesContactoRows(false);

    // -------------------------------------------------------------------------------
    // de la ga obtengo los datos de finalizacion y asigno los valores

    let _final = parGestionAtencion.final;
    setParticularObraSocial(_final.particular_osocial);
    setDisabledGestionParticularObraSocial(true);

    setDisabledConfirmarGestionAtencion(true);
    setDisabledModificarGestionAtencion(false);

    setGestionAtencionConfirmada(true);
    setVentaConcretadaNoConcretada(_final.concretada_nconcretada);
    setDisabledVentaConcretadaNoConcretada(false);

    setEmiteNoEmitePresupuesto(_final.emite_noemite_presupuesto);

    setvalueACAreaEntrega({ id: _final.id_area_entrega, descripcion: _final.descripcion_area_entrega });

    setFinalizar((finalizar) => ({
      ...finalizar,
      areaEntrega: _final.id_area_entrega,
      descripcionAreaEntrega: _final.descripcion_area_entrega,
      fechaEntrega: _final.fecha_entrega ? parse(_final.fecha_entrega, "dd/MM/yyyy", new Date()) : null,
      motivoVentaNoConcretada: _final.id_motivo_venta_no_concretada,
      descripcionMotivoVentaNoConcretada: _final.descripcion_motivo_venta_no_concretada,
      detalleVentaNoConcretada: _final.detalle_venta_no_concretada,
      textoPresupuesto: _final.texto_presupuesto,
    }));

    setDisabledGuardarGA(false);

    if (_final.particular_osocial !== "particular") {
      setShowImportesContado(false);
    }

    // -------------------------------------------------------------------------------
    // obtengo las cobranzas de la ga

    let _cobranzasObject = parGestionAtencion.cobranza.cobranza_list;
    let _cobranzas = [];

    if (_cobranzasObject.length > 0) {
      // si la ga tiene cobranzas

      _cobranzasObject.forEach((item) => {
        // para cada cobranza de la ga

        let _cobranza = {
          id: item.id,
          cobranzaFechaCreacion: item.fecha_creacion,
          cobranzaImporteTotalCobrado: item.importe_total_cobrado,
          cobranzaImporteTotalDescuento: item.importe_total_descuento,
          cobranzaImporteTotalRecargo: item.importe_total_recargo,
          cobranzaCodigo: item.codigo,
          cobranzaEstado: item.estado,
          cobranzaOdooUpdated: item.odoo_updated,
          cobranzaEmitirFactura: item.emitir_factura,
          cobranzaNumeroFactura: item.numero_factura,
          cobranzaUsuario: item.usuario,
          cobranzaNombreUsuario: item.nombre_usuario,
          cobranzaApellidoUsuario: item.apellido_usuario,
          cobranzaArea: item.descripcion_corta_area,
        };
        _cobranzas.push(_cobranza);
      });

      let _totalesCobranza = {
        totalGA: parGestionAtencion.precio_venta_total,
        totalRecargo: parGestionAtencion.cobranza.total_recargo,
        totalDescuento: parGestionAtencion.cobranza.total_descuento,
        totalCobrado: parGestionAtencion.cobranza.total_cobrado,
        totalPendienteCobro: Math.abs(
          parGestionAtencion.precio_venta_total +
          parGestionAtencion.cobranza.total_recargo -
          parGestionAtencion.cobranza.total_descuento -
          parGestionAtencion.cobranza.total_cobrado
        ),
      };
      setTotalesCobranza(_totalesCobranza);
      setShowTabCobranzas(true);
    }
    setCobranzasRows(_cobranzas);

    // -------------------------------------------------------------------------------
    // obtengo los articulos pendientes de entrega de la ga

    let _articulosParaEntregarObject = parGestionAtencion.articulo_para_entregar_list;
    let _articulosParaEntregar = [];

    if (_articulosParaEntregarObject.length > 0) {
      // si la ga tiene articulos para entregar

      _articulosParaEntregarObject.forEach((item) => {
        // para cada articulo para entregar de la ga

        let _articuloParaEntregar = {
          id: item.id,
          tipoArticulo: item.tipo,
          idGcAnteojo: item.tipo === "anteojo" ? item.id_gc_anteojo : "",
          idGcArreglo: item.tipo === "arreglo" ? item.id_gc_arreglo : "",
          idGcOtroProducto: item.tipo === "otro-producto" ? item.id_gc_otro_producto : "",
          idGcLenteContacto: item.tipo === "lente-contacto" ? item.id_gc_lente_contacto : "",
          codigo: item.codigo,
          descripcion: item.descripcion,
          cantidadVendida: item.cantidad_vendida,
          cantidadPendienteEntrega: item.cantidad_pendiente_entrega,
          cantidadPendienteEntregaOriginal: item.cantidad_pendiente_entrega,
          cantidadEntregada: 0,
          cantidadRestante: item.cantidad_pendiente_entrega,
        };
        _articulosParaEntregar.push(_articuloParaEntregar);
      });
    }
    setArticulosParaEntregarRows(_articulosParaEntregar);

    // -------------------------------------------------------------------------------
    // establezco datos predeterminados de la persona que retira

    setEntregaArticulos({
      ...entregaArticulos,
      retiraTipoDocumento: _clienteObject.id_tipo_documento,
      retiraNumeroDocumento: _clienteObject.num_doc,
      retiraTipoNumeroDocumentoDisabled: true,
      retiraNombre: _clienteObject.nombre,
      retiraApellido: _clienteObject.apellido,
      retiraNombreApellidoDisabled: true,
    });

    // -------------------------------------------------------------------------------
    // obtengo las entregas registradas para la ga

    let _entregaArticulosObject = parGestionAtencion.entrega_articulo_list;

    let _entregas = [];

    if (_entregaArticulosObject.length > 0) {
      // si la ga tiene entregas registradas

      _entregaArticulosObject.forEach((item) => {
        // para cada entrega registrada de la ga

        let _entrega = {
          id: item.id_gc_entrega,
          idGcEntrega: item.id_gc_entrega,
          idCliente: item.id_cliente,
          nombreCliente: item.nombre_cliente,
          apellidoCliente: item.apellido_cliente,
          idArea: item.id_area,
          areaDescripcion: item.descripcion_area,
          idUsuario: item.id_usuario,
          nombreUsuario: item.nombre_usuario,
          apellidoUsuario: item.apellido_usuario,
          fechaCreacion: item.fecha_creacion,
          observaciones: item.observaciones,
          estado: item.estado,
          ultimoEstado: item.ultimo_estado,
          fechaEstado: item.fecha_estado,
          motivo: item.motivo
        };
        _entregas.push(_entrega);
      });
    }
    setEntregasArticulosRows(_entregas);

    if ((_articulosParaEntregarObject.length > 0 || _entregaArticulosObject.length > 0) && _cobranzasObject.length > 0) {
      setShowTabEntregaArticulos(true);
    }
  };
  //
  // ################################################################################
  //
  const calcularTotalesGA = () => {
    let _totalAnteojos = 0;
    let _totalAnteojosContado = 0;
    let _totalArreglos = 0;
    let _totalArreglosContado = 0;
    let _totalProductos = 0;
    let _totalProductosContado = 0;
    let _totalLentesContacto = 0;
    let _totalLentesContactoContado = 0;

    anteojos.forEach((item) => {
      if (item.selectedAnteojo === true) {
        _totalAnteojos += item.totalAnteojo;
        _totalAnteojosContado += item.totalAnteojoContado;
      }
    });

    arreglos.forEach((item) => {
      if (item.selectedArreglo === true) {
        _totalArreglos += item.totalArreglo;
        _totalArreglosContado += item.totalArregloContado;
      }
    });

    productosRows.forEach((item) => {
      if (item.productoSelected === true) {
        _totalProductos += item.productoSubtotal;
        _totalProductosContado += item.productoSubtotalContado;
      }
    });

    lentesContactoRows.forEach((item) => {
      if (item.lenteContactoSelected === true) {
        _totalLentesContacto += item.lenteContactoSubtotal;
        _totalLentesContactoContado += item.lenteContactoSubtotalContado;
      }
    });

    setTotalAnteojos(_totalAnteojos);
    setTotalAnteojosContado(_totalAnteojosContado);
    setTotalArreglos(_totalArreglos);
    setTotalArreglosContado(_totalArreglosContado);
    setTotalProductos(_totalProductos);
    setTotalProductosContado(_totalProductosContado);
    setTotalLentesContacto(_totalLentesContacto);
    setTotalLentesContactoContado(_totalLentesContactoContado);

    setFinalizar({
      ...finalizar,
      subTotalGestionAtencion: roundNumber(
        _totalAnteojos + _totalArreglos + _totalProductos + _totalLentesContacto
      ),
      subTotalContadoGestionAtencion: roundNumber(
        _totalAnteojosContado +
        _totalArreglosContado +
        _totalProductosContado +
        _totalLentesContactoContado
      ),
      totalFinalGestionAtencion: roundNumber(
        _totalAnteojos + _totalArreglos + _totalProductos + _totalLentesContacto
      ),
    });

    // setFinalizar({
    // 	...finalizar,
    // 	subTotalGestionAtencion:
    // 		Math.round(
    // 			(_totalAnteojos +
    // 				_totalArreglos +
    // 				_totalProductos +
    // 				_totalLentesContacto) *
    // 				100
    // 		) / 100,
    // 	subTotalContadoGestionAtencion:
    // 		Math.round(
    // 			(_totalAnteojosContado +
    // 				_totalArreglosContado +
    // 				_totalProductosContado +
    // 				_totalLentesContactoContado) *
    // 				100
    // 		) / 100,
    // 	totalFinalGestionAtencion:
    // 		Math.round(
    // 			(_totalAnteojos +
    // 				_totalArreglos +
    // 				_totalProductos +
    // 				_totalLentesContacto) *
    // 				100
    // 		) / 100,
    // });
  };
  //
  // ################################################################################
  //
  const handleChangeParticularObraSocial = (event, newValue) => {
    if (newValue !== null) {
      setParticularObraSocial(newValue);

      if (newValue === "particular") {
        // si es una gestion de atencion particular
        modificarGestionAtencion();
      } else {
        // si es una gestion de atencion de obra social
        setDisabledTotalFinalGestionAtencion(false);
      }
      setDisabledConfirmarGestionAtencion(false);
      setDisabledModificarGestionAtencion(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChangeVentaConcretadaNoConcretada = (event, newValue) => {
    if (newValue !== null) {
      setVentaConcretadaNoConcretada(newValue);

      if (newValue === "venta-concretada") {
        // si venta concretada, limpio los datos de presupuesto

        setFinalizar({
          ...finalizar,
          motivoVentaNoConcretada: "",
          descripcionMotivoVentaNoConcretada: "",
          detalleVentaNoConcretada: "",
          textoPresupuesto: "",
        });
        setvalueACAreaEntrega({ id: "", descripcion: "" });
        setInputvalueACAreaEntrega("");
      } else {
        // si venta no concretada, limpio los datos de forma de pago

        setEmiteNoEmitePresupuesto("emite-presupuesto");
        let _textoPresupuesto = redactarPresupuesto();

        setFinalizar({
          ...finalizar,
          areaEntrega: "",
          fechaEntrega: null,
          textoPresupuesto: _textoPresupuesto,
        });
      }
    }
  };
  //
  // ################################################################################
  //
  const handleChangeEmiteNoEmitePresupuesto = (event, newValue) => {
    if (newValue !== null) {
      setEmiteNoEmitePresupuesto(newValue);

      if (newValue === "emite-presupuesto") {
        // si emite presupuesto
      } else {
        // si no emite presupuesto
      }
    }
  };
  //
  // ################################################################################
  //
  const confirmarGestionAtencion = () => {
    // calculo el pocentaje de reduccion desde el importe total al importe final
    let _porcentajeReduccion =
      (finalizar.totalFinalGestionAtencion * 100) / finalizar.subTotalGestionAtencion;

    // para cada anteojo seleccionado cambio el importe de venta aplicando % de reduccion
    anteojos.forEach((item) => {
      if (item.selectedAnteojo) {
        item.armazonNuevoPrecioVentaArmazon =
          (item.armazonNuevoPrecioVentaArmazon * _porcentajeReduccion) / 100;
        item.cristalPrecioVentaOD = (item.cristalPrecioVentaOD * _porcentajeReduccion) / 100;
        item.cristalPrecioVentaOI = (item.cristalPrecioVentaOI * _porcentajeReduccion) / 100;

        let _totalTratamientos = 0;
        item.tratamientos.forEach((item) => {
          item.anteojoTratamientoPrecioVenta =
            (item.anteojoTratamientoPrecioVenta * _porcentajeReduccion) / 100;
          _totalTratamientos += item.anteojoTratamientoPrecioVenta;
        });
        item.totalAnteojo =
          item.armazonNuevoPrecioVentaArmazon +
          item.cristalPrecioVentaOD +
          item.cristalPrecioVentaOI +
          _totalTratamientos;
      }
    });

    // para cada arreglo seleccionado cambio el importe de venta aplicando % de reduccion
    arreglos.forEach((item) => {
      if (item.selectedArreglo) {
        item.armazonNuevoPrecioVentaArmazon =
          (item.armazonNuevoPrecioVentaArmazon * _porcentajeReduccion) / 100;

        let _totalFornituras = 0;
        item.fornituras.forEach((item) => {
          item.arregloFornituraPrecioVenta =
            (item.arregloFornituraPrecioVenta * _porcentajeReduccion) / 100;
          item.arregloFornituraSubtotal =
            item.arregloFornituraPrecioVenta * item.arregloFornituraCantidad;
          _totalFornituras += item.arregloFornituraSubtotal;
        });

        let _totalServicios = 0;
        item.servicios.forEach((item) => {
          item.arregloServicioPrecioVenta =
            (item.arregloServicioPrecioVenta * _porcentajeReduccion) / 100;
          item.arregloServicioSubtotal =
            item.arregloServicioPrecioVenta * item.arregloServicioCantidad;
          _totalServicios += item.arregloServicioSubtotal;
        });

        let _totalTratamientos = 0;
        item.tratamientos.forEach((item) => {
          item.arregloTratamientoPrecioVenta =
            (item.arregloTratamientoPrecioVenta * _porcentajeReduccion) / 100;
          _totalTratamientos += item.arregloTratamientoPrecioVenta;
        });
        item.totalArreglo =
          item.armazonNuevoPrecioVentaArmazon +
          _totalFornituras +
          _totalServicios +
          _totalTratamientos;
      }
    });

    // para cada otro producto seleccionado cambio el importe de venta aplicando % de reduccion
    productosRows.forEach((item) => {
      if (item.productoSelected) {
        item.productoPrecioVenta = (item.productoPrecioVenta * _porcentajeReduccion) / 100;
        item.productoSubtotal = item.productoPrecioVenta * item.productoCantidad;
      }
    });

    // para cada lc seleccionado cambio el importe de venta aplicando % de reduccion
    lentesContactoRows.forEach((item) => {
      if (item.lenteContactoSelected) {
        item.lenteContactoPrecioVenta =
          (item.lenteContactoPrecioVenta * _porcentajeReduccion) / 100;
        item.lenteContactoSubtotal = item.lenteContactoPrecioVenta * item.lenteContactoCantidad;
      }
    });

    setDisabledCliente(true);
    setDisabledReceta(true);

    setDisabledGestionParticularObraSocial(true);
    setDisabledTotalFinalGestionAtencion(true);
    setDisabledConfirmarGestionAtencion(true);
    setDisabledModificarGestionAtencion(false);

    setDisabledVentaConcretadaNoConcretada(false);

    setExpandedAccordionAnteojo(false);
    setDisabledAccordionAnteojo(true);
    setShowCheckBoxesAnteojosRows(false);
    setShowActionsAnteojosRows(false);

    setExpandedAccordionArreglo(false);
    setDisabledAccordionArreglo(true);
    setShowCheckBoxesArreglosRows(false);
    setShowActionsArreglosRows(false);

    setExpandedAccordionProducto(false);
    setDisabledAccordionProducto(true);
    setShowCheckBoxesProductosRows(false);
    setShowActionsProductosRows(false);

    setExpandedAccordionLenteContacto(false);
    setDisabledAccordionLenteContacto(true);
    setShowCheckBoxesLentesContactoRows(false);
    setShowActionsLentesContactoRows(false);

    setGestionAtencionConfirmada(true);
    setVentaConcretadaNoConcretada("venta-concretada");

    if (particularObraSocial !== "particular") {
      setShowImportesContado(false);
    }

    setDisabledGuardarGA(false);

    calcularTotalesGA();
  };
  //
  // ################################################################################
  //
  const modificarGestionAtencion = () => {
    // para cada anteojo seleccionado restauro el importe de venta original
    anteojos.forEach((item) => {
      if (item.selectedAnteojo) {
        item.armazonNuevoPrecioVentaArmazon = item.armazonNuevoPrecioVentaOriginalArmazon;
        item.cristalPrecioVentaOD = item.cristalPrecioVentaOriginalOD;
        item.cristalPrecioVentaOI = item.cristalPrecioVentaOriginalOI;

        let _totalTratamientos = 0;
        item.tratamientos.forEach((item) => {
          item.anteojoTratamientoPrecioVenta = item.anteojoTratamientoPrecioVentaOriginal;
          _totalTratamientos += item.anteojoTratamientoPrecioVenta;
        });
        item.totalAnteojo =
          item.armazonNuevoPrecioVentaArmazon +
          item.cristalPrecioVentaOD +
          item.cristalPrecioVentaOI +
          _totalTratamientos;
      }
    });

    // para cada arreglo seleccionado cambio el importe de venta aplicando % de reduccion
    arreglos.forEach((item) => {
      if (item.selectedArreglo) {
        item.armazonNuevoPrecioVentaArmazon = item.armazonNuevoPrecioVentaOriginalArmazon;

        let _totalFornituras = 0;
        item.fornituras.forEach((item) => {
          item.arregloFornituraPrecioVenta = item.arregloFornituraPrecioVentaOriginal;
          item.arregloFornituraSubtotal =
            item.arregloFornituraPrecioVenta * item.arregloFornituraCantidad;
          _totalFornituras += item.arregloFornituraSubtotal;
        });

        let _totalServicios = 0;
        item.servicios.forEach((item) => {
          item.arregloServicioPrecioVenta = item.arregloServicioPrecioVentaOriginal;
          item.arregloServicioSubtotal =
            item.arregloServicioPrecioVenta * item.arregloServicioCantidad;
          _totalServicios += item.arregloServicioSubtotal;
        });

        let _totalTratamientos = 0;
        item.tratamientos.forEach((item) => {
          item.arregloTratamientoPrecioVenta = item.arregloTratamientoPrecioVentaOriginal;
          _totalTratamientos += item.arregloTratamientoPrecioVenta;
        });
        item.totalArreglo =
          item.armazonNuevoPrecioVentaArmazon +
          _totalFornituras +
          _totalServicios +
          _totalTratamientos;
      }
    });

    // para cada otro producto seleccionado cambio el importe de venta aplicando % de reduccion
    productosRows.forEach((item) => {
      if (item.productoSelected) {
        item.productoPrecioVenta = item.productoPrecioVentaOriginal;
        item.productoSubtotal = item.productoPrecioVenta * item.productoCantidad;
      }
    });

    // para cada lc seleccionado cambio el importe de venta aplicando % de reduccion
    lentesContactoRows.forEach((item) => {
      if (item.lenteContactoSelected) {
        item.lenteContactoPrecioVenta = item.lenteContactoPrecioVentaOriginal;
        item.lenteContactoSubtotal = item.lenteContactoPrecioVenta * item.lenteContactoCantidad;
      }
    });

    setDisabledCliente(false);
    setDisabledReceta(false);

    setDisabledGestionParticularObraSocial(false);
    setParticularObraSocial("particular");
    setDisabledTotalFinalGestionAtencion(true);
    setDisabledConfirmarGestionAtencion(false);
    setDisabledModificarGestionAtencion(true);

    setDisabledVentaConcretadaNoConcretada(true);

    setExpandedAccordionAnteojo(false);
    setDisabledAccordionAnteojo(false);
    setShowCheckBoxesAnteojosRows(true);
    setShowActionsAnteojosRows(true);

    setExpandedAccordionArreglo(false);
    setDisabledAccordionArreglo(false);
    setShowCheckBoxesArreglosRows(true);
    setShowActionsArreglosRows(true);

    setExpandedAccordionProducto(false);
    setDisabledAccordionProducto(false);
    setShowCheckBoxesProductosRows(true);
    setShowActionsProductosRows(true);

    setExpandedAccordionLenteContacto(false);
    setDisabledAccordionLenteContacto(false);
    setShowCheckBoxesLentesContactoRows(true);
    setShowActionsLentesContactoRows(true);

    setGestionAtencionConfirmada(false);

    setShowImportesContado(true);

    setDisabledGuardarGA(true);

    calcularTotalesGA();
  };
  //
  // ################################################################################
  //
  const redactarPresupuesto = () => {
    // const tab = '\u00A0';
    // const newLine = "\n";

    // let _fecha = "09 de Agosto de 2022";
    // let _encabezado = "OPTICAS LA PIRAMIDE - CADENA DE OPTICAS";
    // let _sucursal = "SUCURSAL PASEO SARMIENTO";
    // let _vendedor = "Sabrina Rosatti";
    // let _linea = "------------------------------------------------------------------------------------------";

    // let _cliente = (cliente.nombre + ", " + cliente.apellido).toUpperCase() + newLine;

    // let _recetaLejos = "";
    // if (recetaLejos.lejosCheck) {
    //   _recetaLejos += "LEJOS: " + newLine;
    //   _recetaLejos += "OD: Esf " + recetaLejos.lejosOdEsfera + " Cil " + recetaLejos.lejosOdCilindro + " Eje " + recetaLejos.lejosOdEje + newLine;
    //   _recetaLejos += "OI: Esf " + recetaLejos.lejosOiEsfera + " Cil " + recetaLejos.lejosOiCilindro + " Eje " + recetaLejos.lejosOiEje + newLine;
    // }

    // let _recetaCerca = "";
    // if (recetaCerca.cercaCheck) {
    //   _recetaCerca += "CERCA: " + newLine;
    //   _recetaCerca += "OD: Esf " + recetaCerca.cercaOdEsfera + " Cil " + recetaCerca.cercaOdCilindro + " Eje " + recetaCerca.cercaOdEje + newLine;
    //   _recetaCerca += "OI: Esf " + recetaCerca.cercaOiEsfera + " Cil " + recetaCerca.cercaOiCilindro + " Eje " + recetaCerca.cercaOiEje + newLine;
    // }

    // let _recetaIntermedia = "";
    // if (recetaIntermedia.intermediaCheck) {
    //   _recetaIntermedia += "INTERMEDIA: " + newLine;
    //   _recetaIntermedia += "OD: Esf " + recetaIntermedia.intermediaOdEsfera + " Cil " + recetaIntermedia.intermediaOdCilindro + " Eje " + recetaIntermedia.intermediaOdEje + newLine;
    //   _recetaIntermedia += "OI: Esf " + recetaIntermedia.intermediaOiEsfera + " Cil " + recetaIntermedia.intermediaOiCilindro + " Eje " + recetaIntermedia.intermediaOiEje + newLine;
    // }

    // let _medico = recetaOtrosDatos.medico + newLine;
    // let _instituto = recetaOtrosDatos.instituto + newLine;
    // let _fechaReceta = recetaOtrosDatos.fechaReceta + newLine;

    // let _textoPresupuesto = "";
    // _textoPresupuesto += _fecha + newLine;
    // _textoPresupuesto += _encabezado + newLine;
    // _textoPresupuesto += _sucursal + newLine;
    // _textoPresupuesto += _vendedor + newLine;
    // _textoPresupuesto += _linea + newLine;

    // if (_recetaLejos || _recetaCerca || _recetaIntermedia) {
    //   _textoPresupuesto += "RECETA" + newLine;
    //   _textoPresupuesto += "Medico: " + _medico + newLine;
    //   _textoPresupuesto += "Instituto: " + _instituto + newLine;
    //   _textoPresupuesto += "Fecha de la receta: " + _fechaReceta + newLine;
    //   if (_recetaLejos) {
    //     _textoPresupuesto += _recetaLejos + newLine;
    //   }
    //   if (_recetaCerca) {
    //     _textoPresupuesto += _recetaCerca + newLine;
    //   }
    //   if (_recetaIntermedia) {
    //     _textoPresupuesto += _recetaIntermedia + newLine;
    //   }
    // }

    let _textoPresupuesto = "Presupuesto autogenerado";

    return _textoPresupuesto;
  };
  //
  // ################################################################################
  //
  const entregarArticulos = (parRow, parAction) => {

    let _articulosParaEntregar = [];

    if (parAction === "entregar-todo") {

      articulosParaEntregarRows.forEach((item) => {
        let _articuloParaEntregar = {
          ...item,
          // cantidadPendienteEntrega: 0,
          cantidadEntregada: item.cantidadPendienteEntregaOriginal,
          cantidadRestante: 0
        }
        _articulosParaEntregar.push(_articuloParaEntregar);
      });
      setArticulosParaEntregarRows(_articulosParaEntregar);
    } else if (parAction === "delete") {

      let _articuloParaEntregar = articulosParaEntregarRows.find((item) => item.id === parRow.id);

      // _articuloParaEntregar.cantidadPendienteEntrega = _articuloParaEntregar.cantidadPendienteEntregaOriginal;
      _articuloParaEntregar.cantidadEntregada = 0;
      _articuloParaEntregar.cantidadRestante = _articuloParaEntregar.cantidadPendienteEntregaOriginal;

      _articulosParaEntregar = articulosParaEntregarRows.map((item) =>
        item.id === parRow.id ? _articuloParaEntregar : item
      );
      setArticulosParaEntregarRows(_articulosParaEntregar);
    } else if (parAction === "deliver") {

      _articulosParaEntregar = articulosParaEntregarRows.map((item) =>
        item.id === parRow.id ? parRow : item
      );
      setArticulosParaEntregarRows(_articulosParaEntregar);
    }

    const _totalArticulosPendienteEntrega = _articulosParaEntregar.reduce((acc, item) => acc + item.cantidadPendienteEntrega, 0);
    const _totalArticulosEntregados = _articulosParaEntregar.reduce((acc, item) => acc + item.cantidadEntregada, 0);

    setEntregaArticulos({
      ...entregaArticulos,
      totalArticulosPendienteEntrega: _totalArticulosPendienteEntrega,
      totalArticulosEntregados: _totalArticulosEntregados,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeEntregaArticulos = (e) => {
    setEntregaArticulos({
      ...entregaArticulos,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const data = {
    isDoingSomething,
    setIsDoingSomething,
    tabGestionAtencionValue,
    setTabGestionAtencionValue,
    gaAction,
    setGestionAtencion,

    codigoGA,
    setCodigoGA,
    sucursalGA,
    usuarioGA,
    fechaCreacionGA,
    validarDatosCliente,
    validarDatosReceta,
    prepararGestionAtencionObject,
    limpiaAnteojo,
    limpiaArreglo,
    limpiaGA,
    prismaOptions,
    isSetClient,
    setIsSetClient,
    isNewClient,
    setIsNewClient,
    cliente,
    setDisabledCliente,
    handleChangeCliente,
    handleChangeClienteFechaNacimiento,
    setCliente,
    disabledCliente,
    //
    // receta
    //
    isRecetaError,
    recetaLejos,
    setRecetaLejos,
    recetaLejosDisabled,
    handleChangeRecetaLejos,
    recetaCerca,
    recetaCercaDisabled,
    handleChangeRecetaCerca,
    recetaIntermedia,
    recetaIntermediaDisabled,
    handleChangeRecetaIntermedia,
    recetaOtrosDatos,
    handleChangeRecetaOtrosDatos,
    handleChangeRecetaOtrosDatosFechaReceta,
    errorLejosOdEsfera,
    setErrorLejosOdEsfera,
    errorLejosOdCilindro,
    setErrorLejosOdCilindro,
    errorLejosOdEje,
    setErrorLejosOdEje,
    errorLejosOdPrisma,
    setErrorLejosOdPrisma,
    errorLejosOdEjePrisma,
    setErrorLejosOdEjePrisma,
    errorLejosOiEsfera,
    setErrorLejosOiEsfera,
    errorLejosOiCilindro,
    setErrorLejosOiCilindro,
    errorLejosOiEje,
    setErrorLejosOiEje,
    errorLejosOiPrisma,
    setErrorLejosOiPrisma,
    errorLejosOiEjePrisma,
    setErrorLejosOiEjePrisma,
    errorCercaOdEsfera,
    setErrorCercaOdEsfera,
    errorCercaOdCilindro,
    setErrorCercaOdCilindro,
    errorCercaOdEje,
    setErrorCercaOdEje,
    errorCercaOdPrisma,
    setErrorCercaOdPrisma,
    errorCercaOdEjePrisma,
    setErrorCercaOdEjePrisma,
    errorCercaOiEsfera,
    setErrorCercaOiEsfera,
    errorCercaOiCilindro,
    setErrorCercaOiCilindro,
    errorCercaOiEje,
    setErrorCercaOiEje,
    errorCercaOiPrisma,
    setErrorCercaOiPrisma,
    errorCercaOiEjePrisma,
    setErrorCercaOiEjePrisma,
    errorIntermediaOdEsfera,
    setErrorIntermediaOdEsfera,
    errorIntermediaOdCilindro,
    setErrorIntermediaOdCilindro,
    errorIntermediaOdEje,
    setErrorIntermediaOdEje,
    errorIntermediaOdPrisma,
    setErrorIntermediaOdPrisma,
    errorIntermediaOdEjePrisma,
    setErrorIntermediaOdEjePrisma,
    errorIntermediaOiEsfera,
    setErrorIntermediaOiEsfera,
    errorIntermediaOiCilindro,
    setErrorIntermediaOiCilindro,
    errorIntermediaOiEje,
    setErrorIntermediaOiEje,
    errorIntermediaOiPrisma,
    setErrorIntermediaOiPrisma,
    errorIntermediaOiEjePrisma,
    setErrorIntermediaOiEjePrisma,
    disabledReceta,
    //
    // Anteojos - estado de accordions
    //
    expandedAccordionAnteojo,
    setExpandedAccordionAnteojo,
    disabledAccordionAnteojo,
    expandedAccordionAnteojoAnteojo,
    setExpandedAccordionAnteojoAnteojo,
    expandedAccordionAnteojoCristales,
    setExpandedAccordionAnteojoCristales,
    expandedAccordionAnteojoTratamientos,
    setExpandedAccordionAnteojoTratamientos,
    expandedAccordionAnteojoObservaciones,
    setExpandedAccordionAnteojoObservaciones,
    //
    // Anteojo - estado de tab de nuevo cliente
    //
    anteojoTabNuevoDeCliente,
    setAnteojoTabNuevoDeCliente,
    //
    // Anteojo - anteojos
    //
    initialAnteojoArmazonNuevo,
    anteojoAction,
    anteojoArmazonNuevo,
    handleChangeAnteojoArmazonNuevo,
    setAnteojoArmazonNuevo,
    initialAnteojoArmazonCliente,
    anteojoArmazonCliente,
    handleChangeAnteojoArmazonCliente,
    setAnteojoArmazonCliente,
    totalAnteojos,
    totalAnteojosContado,
    //
    // Anteojo - Cristales
    //
    anteojoCristalesTipoAnteojoOptions,
    initialAnteojoCristales,
    anteojoCristales,
    handleChangeAnteojoCristales,
    setAnteojoCristales,
    totalCristales,
    totalCristalesContado,
    //
    // Anteojo - Tratamientos
    //
    anteojoTratamientosOjoOptions,
    initialAnteojoTratamiento,
    anteojoTratamiento,
    handleChangeAnteojoTratamiento,
    setAnteojoTratamiento,
    anteojoTratamientosRows,
    setAnteojoTratamientosRows,
    totalAnteojoTratamientos,
    totalAnteojoTratamientosContado,
    //
    // Anteojo - Observaciones
    //
    anteojoObservaciones,
    handleChangeAnteojoObservaciones,
    //
    // Anteojo - Totales
    //
    anteojos,
    anteojosSelected,
    totalAnteojo,
    totalAnteojoContado,
    guardarAnteojoEnTablaAnteojos,
    obtenerAnteojo,
    quitarAnteojo,
    seleccionarAnteojos,
    showCheckBoxesAnteojosRows,
    showActionsAnteojosRows,
    //
    // Arreglos
    //
    arregloAction,
    //
    // Arreglos - estado de accordions
    //
    expandedAccordionArreglo,
    setExpandedAccordionArreglo,
    disabledAccordionArreglo,
    expandedAccordionArregloAnteojoCristales,
    setExpandedAccordionArregloAnteojoCristales,
    expandedAccordionArregloPaseCristales,
    setExpandedAccordionArregloPaseCristales,
    expandedAccordionArregloServicios,
    setExpandedAccordionArregloServicios,
    expandedAccordionArregloTratamientos,
    setExpandedAccordionArregloTratamientos,
    expandedAccordionArregloFornituras,
    setExpandedAccordionArregloFornituras,
    expandedAccordionArregloObservaciones,
    setExpandedAccordionArregloObservaciones,
    //
    // Arreglos - Anteojo y Cristales
    //
    arregloAnteojoCristales,
    handleChangeArregloAnteojoCristales,
    //
    // Arreglos - estado de tab de nuevo cliente
    //
    arregloTabNuevoDeCliente,
    setArregloTabNuevoDeCliente,
    //
    // Arreglo - arreglos
    //
    initialArregloArmazonNuevo,
    // arregloAction,
    arregloArmazonNuevo,
    setArregloArmazonNuevo,
    handleChangeArregloArmazonNuevo,
    initialArregloArmazonCliente,
    arregloArmazonCliente,
    handleChangeArregloArmazonCliente,
    setArregloArmazonCliente,
    totalArreglos,
    totalArreglosContado,
    //
    // Arreglos - Servicios
    //
    initialArregloServicio,
    arregloServicio,
    handleChangeArregloServicio,
    setArregloServicio,
    arregloServiciosRows,
    setArregloServiciosRows,
    totalArregloServicios,
    totalArregloServiciosContado,
    //
    // Arreglos - Tratamientos
    //
    arregloTratamientosOjoOptions,
    initialArregloTratamiento,
    arregloTratamiento,
    handleChangeArregloTratamiento,
    setArregloTratamiento,
    arregloTratamientosRows,
    setArregloTratamientosRows,
    totalArregloTratamientos,
    totalArregloTratamientosContado,
    //
    // Arreglos - Fornituras
    //
    initialArregloFornitura,
    arregloFornitura,
    handleChangeArregloFornitura,
    setArregloFornitura,
    arregloForniturasRows,
    setArregloForniturasRows,
    totalArregloFornituras,
    totalArregloForniturasContado,
    //
    // Arreglos - Observaciones
    //
    arregloObservaciones,
    handleChangeArregloObservaciones,
    //
    // Arreglos - Totales
    //
    arreglos,
    arreglosSelected,
    totalArreglo,
    totalArregloContado,
    guardarArregloEnTablaArreglos,
    obtenerArreglo,
    quitarArreglo,
    seleccionarArreglos,
    showCheckBoxesArreglosRows,
    showActionsArreglosRows,
    //
    // otros productos
    //
    initialProducto,
    producto,
    setProducto,
    handleChangeProducto,
    productosRows,
    setProductosRows,
    productosSelected,
    setProductosSelected,
    totalProductos,
    totalProductosContado,
    seleccionarProductos,
    showCheckBoxesProductosRows,
    showActionsProductosRows,
    //
    // otros productos - estado de acordions
    //
    expandedAccordionProducto,
    setExpandedAccordionProducto,
    disabledAccordionProducto,
    //
    // Lentes de Contacto
    //
    lenteContactoAction,
    lenteContactoOjoOptions,
    initialLenteContacto,
    lenteContacto,
    setLenteContacto,
    handleChangeLenteContacto,

    lentesContactoRows,
    setLentesContactoRows,
    lentesContactoSelected,
    totalLentesContacto,
    totalLentesContactoContado,
    seleccionarLentesContacto,
    disabledDatosLenteContacto,
    setDisabledDatosLenteContacto,
    obtenerLenteContacto,
    quitarLenteContacto,
    guardarLenteContacto,
    limpiaLenteContacto,
    showCheckBoxesLentesContactoRows,
    showActionsLentesContactoRows,
    //
    // otros productos - estado de acordions
    //
    expandedAccordionLenteContacto,
    setExpandedAccordionLenteContacto,
    disabledAccordionLenteContacto,
    //
    // total de la ga
    //
    // ventaConcretada,
    // setVentaConcretada,
    // labelVentaConcretada,
    // setLabelVentaConcretada,
    // confeccionarPresupuesto,
    // setConfeccionarPresupuesto,
    // labelConfeccionarPresupuesto,
    // setLabelConfeccionarPresupuesto,
    // setFinalizar,

    finalizar,
    setFinalizar,
    valueACAreaEntrega,
    setvalueACAreaEntrega,
    inputvalueACAreaEntrega,
    setInputvalueACAreaEntrega,
    particularObraSocial,
    disabledGestionParticularObraSocial,
    disabledTotalFinalGestionAtencion,
    disabledConfirmarGestionAtencion,
    disabledModificarGestionAtencion,

    ventaConcretadaNoConcretada,
    disabledVentaConcretadaNoConcretada,
    gestionAtencionConfirmada,
    emiteNoEmitePresupuesto,

    handleChangeFinalizar,
    handleChangeFechaEntrega,
    handleBlurFinalizar,
    handleChangeParticularObraSocial,
    handleChangeVentaConcretadaNoConcretada,
    handleChangeEmiteNoEmitePresupuesto,

    confirmarGestionAtencion,
    modificarGestionAtencion,

    disabledGuardarGA,

    showImportesContado,

    cobranzasRows,
    showTabCobranzas,
    totalesCobranza,

    articulosParaEntregarRows,
    entregasArticulosRows,
    showTabEntregaArticulos,
    entregarArticulos,
    entregaArticulos,
    setEntregaArticulos,
    handleChangeEntregaArticulos
  };

  return <GestionAtencionContext.Provider value={data}>{children}</GestionAtencionContext.Provider>;
};

export { GestionAtencionProvider };
export default GestionAtencionContext;
